import Button from 'apollo-react/components/Button';
import Card from 'apollo-react/components/Card';
import CardContent from 'apollo-react/components/CardContent';
import CardHeader from 'apollo-react/components/CardHeader';
import Container from 'apollo-react/components/Container';
import Grid from 'apollo-react/components/Grid';
import TextField from 'apollo-react/components/TextField';
import Typography from 'apollo-react/components/Typography';
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import ConfirmDialog from '../common/ConfirmDialog';
import { API_URL, NO_SEND_FLG, PROMPTLY_FLG, SYS_ROLE } from '../common/Constants';
import DetailDialog from '../common/DetailDialog';
import Dialog from '../common/Dialog';
import Loading from '../common/Loading';
import { getApi, postApi, deleteApi, setURL, redirectToLogin, setMessage, toISOStringWithTimezone } from '../common/Utils';
import { Box } from '@mui/material';
import './UploadSchedule.scss';
import Checkbox from '@mui/material/Checkbox';
import { useForm, useFieldArray } from "react-hook-form";
import IconButton from '@mui/material/IconButton';
import Trash from 'apollo-react-icons/Trash';
import Radio from 'apollo-react/components/Radio';
import RadioGroup from 'apollo-react/components/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Divider, Tooltip } from '@mui/material';
import moment from 'moment';
import TimePicker from 'apollo-react/components/TimePicker';
import DatePicker from 'apollo-react/components/DatePicker';
import FileSelectBox from '../common/FileSelectBox';
import upsertUploadSchedule from '../json/upsertUploadSchedule.json';
import upScheduleList from '../json/upScheduleList.json';
import upScheduleResult from '../json/upScheduleResult.json';
import shareFileSampleList from '../json/shareFileList.json';
import dayjs from 'dayjs';
import Download from 'apollo-react-icons/Download';

function UploadSchedule() {
	const location = useLocation();
	const [t] = useTranslation();
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);
	// ★★★ 追加：ファイル保管期間の定数 ★★★
    const FILE_PERIOD = {
        DAYS_15: '15',
        DAYS_30: '30',
        DAYS_45: '45',
        DAYS_60: '60',
        DAYS_75: '75',
        DAYS_90: '90',
    };
	const DIALOG_STATUS = {
		NO_DIALOG: '0',
		OK_DIALOG: '1',
		DETAIL_DIALOG: '2',
		SAVE_CONFIRM_DIALOG: '3',
		CANCEL_CONFIRM_DIALOG: '4',
		DELETE_CONFIRM_DIALOG: '5',
		COMPLETE_DIALOG: '6',
		OK_DIALOG_BACK: '7',
		DETAIL_DIALOG_BACK: '8',
		SUBMIT_SUCCESS_DIALOG: '9',
		SWITCH_CONFIRM_DIALOG: '12',
		COPY_SWITCH_CONFIRM_DIALOG: '13',
		FORM_SWITCH_CONFIRM_DIALOG: '14',
	};

	const [dialogStatus, setDialogStatus] = useState(DIALOG_STATUS.NO_DIALOG);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [dialogContent, setDialogContent] = useState('');
	const [detailContent, setDetailContent] = useState('');
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
	const [confirmDialogContent, setConfirmDialogContent] = useState('');
	const [openDate, setOpenDate] = useState(null);
	const [pendingAction, setPendingAction] = useState(null);
	const [isFormMode, setIsFormMode] = useState(false);
	const [currentFormMode, setCurrentFormMode] = useState(null);
	const [isSharedUserConfigured, setIsSharedUserConfigured] = useState(false);
	const [shareFileList, setShareFileList] = useState([]); // 共有フォルダ内のファイル一覧を保持する状態変数
	const [shareFolderSeverName, setShareFolderSeverName] = useState('');

	// フォルダ管理画面orフォルダ作成画面からの値をもとに値をセットする												
	const { auditName, auditCode, orgName, orgLevel0Code, projName, projCode } = location.state || {};

	// 選択されたファイル名の配列を管理する状態を追加
	const [selectedFileNamesFromFolder, setSelectedFileNamesFromFolder] = useState([]);

	// 権限設定情報の入力内容（APIで使用する）												
	// formValues の初期化を修正
	const [formValues, setFormValues] = useState({
		forInsert: null, // true:追加 false: 編集
		auditCode: auditCode,
		orgLevel0Code: orgLevel0Code,
		projectCode: projCode,
		auditName: auditName, // 表示用
		orgName: orgName, // 表示用
		projName: projName, // 表示用
		sharedFolderName: '', // 追加
		notices: '', // 追加
		information: '', // 追加
		promptyFlg: '1', // 追加
		openDisplayDate: null, // 追加
		noSendFlg: '0',
		publishImmediately: true, // 編集時の元データ表示用
		publishSelectedDate: true, // 編集時の元データ表示用
		fileNames: [],
		scheduleNo: '',
		scheduleName: '',
		// ★★★ 追加 ★★★
		filePeriod: '90', // デフォルト90日
	});

	// 状態変数
	const [scheduleList, setScheduleList] = useState([]);
	const [fileList, setFileList] = useState([]);
	const [uploadDate, setUploadDate] = useState(null);
	const [uploadTime, setUploadTime] = useState('');
	const [openTime, setOpenTime] = useState('');
	const [uploadDateFormatErrFlg, setUploadDateFormatErrFlg] = useState(false);
	const [uploadDatePastErrFlg, setUploadDatePastErrFlg] = useState(false);
	const [uploadTimeFormatErrFlg, setUploadTimeFormatErrFlg] = useState(false);
	const [folderFiles, setFolderFiles] = useState([]);

	/**												
	 * 共通エラー処理												
	 * @param {object} error エラーオブジェクト												
	 * @param {string} detailErrorMessage 詳細ダイアログに設定するエラーメッセージ												
	 */
	const commonError = (error, detailErrorMessage) => {
		if (error.name === 'MaintenanceApiError') {
			navigate('/', { state: { maintenanceFlg: true, } });
		} else if (error.name === 'CustomApiError') {
			const message = error.message;
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			setDialogOpen(true);
			setDialogContent(message);
		} else {
			setDialogStatus(DIALOG_STATUS.DETAIL_DIALOG);
			setDialogOpen(true);
			setDialogContent(detailErrorMessage);
			setDetailContent(error.stack);
		}
	};											

	/**												
	 * ダイアログでOKボタン押下時の処理												
	 */
	const onOk = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setDialogOpen(false);
	};

	/**												
	 * 確認ダイアログでキャンセルボタン押下時の処理												
	 */
	const onCancel = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setConfirmDialogOpen(false);
		setPendingAction(null); // 保留中のアクションをクリア
	};

	// 登録ボタン押下処理												
	const submitProcess = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setConfirmDialogOpen(false);

		const url = setURL(API_URL.UPLOADSCHEDULE_UPSERT);
		let formData = new FormData();
		formData.append('forInsert', formValues.forInsert);
		formData.append('auditCode', formValues.auditCode);
		formData.append('projCode', formValues.projectCode);
		formData.append('scheduleNo', formValues.scheduleNo);
		formData.append('scheduleName', formValues.scheduleName);

		// fileListからnamesのみを取り出して配列にセット
		const fileNamesArray = Array.isArray(fileList) 
		? fileList.map(file => file.name || file.fileName || file)
		: [];

		formValues.fileNames = fileNamesArray;
		// UTF-8対応のBase64エンコーディング
		const utf8ToBase64 = (str) => {
			// UTF-8文字列をUint8Arrayに変換
			const utf8Bytes = new TextEncoder().encode(str);
			// Uint8ArrayをBase64文字列に変換
			let binary = '';
			utf8Bytes.forEach(byte => binary += String.fromCharCode(byte));
			return btoa(binary);
		};

		const encodedfileNames = utf8ToBase64(JSON.stringify(formValues.fileNames));
		formData.append('fileNames', encodedfileNames);

		// openDateはDateオブジェクトなので、dayjsでラップしてからフォーマット
		const upDateStr = dayjs(uploadDate).format('YYYY-MM-DD');
		formData.append('upScheduleDate', toISOStringWithTimezone(dayjs(upDateStr + ' ' + uploadTime).toDate()));

		formData.append('notices', formValues.notices);
		formData.append('information', formValues.information);
		if (formValues.promptyFlg === PROMPTLY_FLG.PUBLISH_SELECT_DATE) {
			// openDateはDateオブジェクトなので、dayjsでラップしてからフォーマット
			const openDateStr = dayjs(openDate).format('YYYY-MM-DD');
			formData.append('openDate', toISOStringWithTimezone(dayjs(openDateStr + ' ' + openTime).toDate()));
		};
		formData.append('noSendFlg', formValues.noSendFlg);
		formData.append('promptlyFlg', formValues.promptyFlg);

		// ★★★ 追加：ファイル保管期間 ★★★
		formData.append('filePeriod', formValues.filePeriod);

		const postApiParam = {
			url: url,
			sysRole: SYS_ROLE.UPLOAD_SCHEDULE,
			body: formData,
			success: submitSuccess,
			error: submitError,
			json: upsertUploadSchedule
		};
		postApi(postApiParam);
	}

	/**												
	 * キャンセルボタン押下時の処理												
	 */
	const handleCancelClick = () => {
		commonBack();
	}

	/**
	 * 必須項目がすべて入力されているかチェックする関数
	 * @returns {boolean} すべての必須項目が入力されている場合はtrue
	 */
	const isFormValid = () => {
		// 結果確認モードの場合は常にfalse（登録ボタン非活性）
		if (isResultCheckMode) {
			return false;
		}

		// フォームが表示されていない場合はfalse
		if (!showScheduleForm) {
			return false;
		}

		// 1. スケジュール名チェック
		if (!formValues.scheduleName || formValues.scheduleName.trim() === '') {
			return false;
		}

		// スケジュール名の重複チェックを追加
		if (isDuplicateScheduleName(formValues.scheduleName)) {
			return false;
		}

		// 2. ファイル名チェック（少なくとも1つのファイルが必要で、空でないこと）
		if (!fileList || fileList.length === 0) {
			return false;
		}
		
		// ファイルリストに空のファイル名がないかチェック
		const hasValidFiles = fileList.some(file => file.name && file.name.trim() !== '');
		if (!hasValidFiles) {
			return false;
		}

		// ファイルリストに空のファイル名が含まれている場合もfalse（message.1007041対応）
		const hasEmptyFiles = fileList.some(file => !file.name || file.name.trim() === '');
		if (hasEmptyFiles) {
			return false;
		}

		// 3. アップロード日時チェック
		if (!uploadDate || !uploadTime || uploadTime.trim() === '') {
			return false;
		}

		// エラーフラグがある場合はfalse
		if (uploadDateFormatErrFlg || uploadDatePastErrFlg || uploadTimeFormatErrFlg) {
			return false;
		}

		// 4. 公開日時チェック（選択日時で公開の場合のみ）
		if (formValues.promptyFlg === PROMPTLY_FLG.PUBLISH_SELECT_DATE) {
			if (!openDate || !openTime || openTime.trim() === '') {
				return false;
			}
			
			// 公開日時のエラーフラグがある場合はfalse
			if (openDateFormatErrFlg || openDatePastErrFlg || openTimeFormatErrFlg || openDateBeforeUploadErrFlg) {
				return false;
			}

			 // 公開日時がアップロード日時より前かチェック
			 if (uploadDate && uploadTime) {
				const uploadDateTime = new Date(uploadDate);
				const timeStr = uploadTime.trim();
				let hours, minutes;
				
				if (timeStr.includes('AM') || timeStr.includes('PM')) {
					const timeMoment = moment(timeStr, ['h:mm A', 'hh:mm A'], true);
					if (timeMoment.isValid()) {
						hours = timeMoment.hours();
						minutes = timeMoment.minutes();
					} else {
						return false;
					}
				} else {
					const timeParts = timeStr.split(':');
					hours = parseInt(timeParts[0], 10);
					minutes = parseInt(timeParts[1], 10);
				}
				uploadDateTime.setHours(hours, minutes, 0, 0);
				
				const openDateTime = new Date(openDate);
				const openTimeStr = openTime.trim();
				let openHours, openMinutes;
				
				if (openTimeStr.includes('AM') || openTimeStr.includes('PM')) {
					const openTimeMoment = moment(openTimeStr, ['h:mm A', 'hh:mm A'], true);
					if (openTimeMoment.isValid()) {
						openHours = openTimeMoment.hours();
						openMinutes = openTimeMoment.minutes();
					} else {
						return false;
					}
				} else {
					const openTimeParts = openTimeStr.split(':');
					openHours = parseInt(openTimeParts[0], 10);
					openMinutes = parseInt(openTimeParts[1], 10);
				}
				openDateTime.setHours(openHours, openMinutes, 0, 0);
				
				// 公開日時がアップロード日時より前の場合
				if (openDateTime < uploadDateTime) {
					return false;
				}
			}
		}

		// 5. 通知メール送信フラグ（noSendFlgはデフォルト値があるので常にOK）

		return true;
	};

	// スケジュール登録処理完了時												
	async function submitSuccess(responseData) {
		setIsFormMode(false);
		setCurrentFormMode(null);
		setShowScheduleForm(false);

		// APIから最新のスケジュールリストを再取得
		const refreshScheduleList = async () => {
			try {
				const scheListUrl = setURL(API_URL.UPLOADSCHEDULE_SCHEDULELIST);
				const scheListParams = {};
				scheListParams['auditCode'] = formValues.auditCode;
				scheListParams['projCode'] = formValues.projectCode;
				const getScheListParam = String(new URLSearchParams(scheListParams));
				const getScheListApiParam = {
					url: scheListUrl + '?' + getScheListParam,
					sysRole: SYS_ROLE.UPLOAD_SCHEDULE,
					success: getUpScheListSuccess,
					error: commonError,
					json: upScheduleList,
				}
				await getApi(getScheListApiParam);
			} catch (error) {
				console.error('Failed to refresh schedule list:', error);
			}
		};

		 // スケジュールリストを再取得
		 await refreshScheduleList();
		
		setDialogStatus(DIALOG_STATUS.SUBMIT_SUCCESS_DIALOG);
		const message = format(t('message.1003500'), "");
		setDialogOpen(true);
		setDialogContent(message);
	};

	/**												
	 * スケジュール登録処理の失敗時の処理												
	 * @param {object} error エラーオブジェクト												
	 */
	function submitError(error) {
		const detailErrorMessage = 'スケジュール登録処理でエラーが発生しました。\n(An error occurred during the select item process.)';
		commonError(error, detailErrorMessage);

		//認証期限切れの場合は再ログイン											
		redirectToLogin();
	};

	const deleteScheduleProcess= (scheduleNo) => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setConfirmDialogOpen(false);

		const url = setURL(API_URL.UPLOADSCHEDULE_DELETE);
		let formData = new FormData();
		formData.append('auditCode', auditCode);
		formData.append('projCode', projCode);
		formData.append('scheduleNo', scheduleNo);

		const postApiParam = {
			url: url,
			sysRole: SYS_ROLE.UPLOAD_SCHEDULE,
			body: formData,
			success: deleteScheduleSuccess,
			error: deleteScheduleError,
		};
		deleteApi(postApiParam);
	};

	/**
	 * スケジュール削除APIの成功時の処理
	 */
	function deleteScheduleSuccess() {
		// UIからも削除
		const newScheduleList = scheduleList.filter(item => !item.selected);
		setScheduleList(newScheduleList);

		setDialogStatus(DIALOG_STATUS.COMPLETE_DIALOG);
		const message = format(t('message.1007010'), "");
		setDialogOpen(true);
		setDialogContent(message);
	};

	/**
	 * スケジュール削除APIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function deleteScheduleError(error) {
		if (error.name === 'MaintenanceApiError') {
			navigate('/', { state: { maintenanceFlg: true, } });
		} else if (error.name === 'CustomApiError') {
			//入力テキストに禁則文字が含まれている場合、azureのインフラルールによりエラーとなる
			//ただし、エラーは403 Forbiddenとしか返って来ない（＝禁則文字によるエラーだと判別できない）ため、メッセージを変更する
			const forbidCharPat1 = /.+403 Forbidden.+/;
			const forbidCharPat2 = /.+Microsoft-Azure-Application-Gateway.+/;
			if ((error.message.match(forbidCharPat1)) && (error.message.match(forbidCharPat2))) {
				const message = t('message.1000810');
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				setDialogOpen(true);
				setDialogContent(message);

				//認証期限切れの場合は再ログイン
				redirectToLogin();
			} else {
				const message = error.message;
				setDialogStatus(DIALOG_STATUS.OK_DIALOG_BACK);
				setDialogOpen(true);
				setDialogContent(message);

				//認証期限切れの場合は再ログイン
				redirectToLogin();
			}
		} else {
			const message = t('message.9999999');
			setDialogStatus(DIALOG_STATUS.DETAIL_DIALOG);
			setDialogOpen(true);
			setDialogContent(message);
			setDetailContent(error.stack);

			//認証期限切れの場合は再ログイン
			redirectToLogin();
		}

		//認証期限切れの場合は再ログイン
		redirectToLogin();
	};

	/**												
	 * 共通フォルダ管理画面遷移処理												
	 */
	const commonBack = () => {
		// フォルダ管理画面へ遷移											
		navigate('/deliveryfilemanagement');
	};

	const onFinished = () => {
		const param = {
			auditName: formValues.auditName,
			auditCode: formValues.auditCode,
			orgName: formValues.orgName,
			orgLevel0Code: formValues.orgLevel0Code,
			projectCode: formValues.projectCode,
			projName: formValues.projName,
		};

		// URLにパラメータを追加											
		let newUrl = new URL(window.location.href);
		Object.keys(param).forEach(key => newUrl.searchParams.set(key, param[key]));

		// 新しいURLにリダイレクト											
		window.location.href = newUrl.toString();
	}

	/**												
	 * 登録ボタン押下時の処理												
	 */
	const handleSubmitClick = () => {
		if (!validateUploadDateTime()) {
			return;
		}
		
		setDialogStatus(DIALOG_STATUS.SAVE_CONFIRM_DIALOG);
		const message = t('message.1007030');
		setConfirmDialogOpen(true);
		setConfirmDialogContent(message);
	}

	/**												
	 * 削除ボタン押下時の処理												
	 */
	const handleDeleteClick = () => {
		if (isFormMode && currentFormMode !== 'resultCheck') {
			setPendingAction('delete');
			setDialogStatus(DIALOG_STATUS.FORM_SWITCH_CONFIRM_DIALOG);
			setConfirmDialogOpen(true);
			setConfirmDialogContent(t('message.1007031'));
			return;
		}

		// 結果確認モードを解除
		setIsResultCheckMode(false);
		
		// 既存の処理
		const selectedSchedule = scheduleList.find(item => item.selected);
		if (selectedSchedule) {
			setDialogStatus(DIALOG_STATUS.DELETE_CONFIRM_DIALOG);
			const message = t('message.1007000');
			setConfirmDialogOpen(true);
			setConfirmDialogContent(message);
		}
	}

	// 共有フォルダ内ファイル一覧取得成功時の処理
	const getShareFileListSuccess = (response) => {
		const fileList = response.map(item => ({
			name: item.fileName
    	})) || [];
		
		setShareFileList(fileList);
	};

    /**												
    * 共有フォルダ内ファイル一覧取得失敗時の処理												
    * @param {object} error エラーオブジェクト												
    */
	const getShareFileListError = (error) => {
		const detailErrorMessage = '共有フォルダ内ファイル一覧取得でエラーが発生しました。\n(An error occurred during the select item process.)';
		commonError(error, detailErrorMessage);
	};

	// // C#のプレースホルダーをJavascriptで使用するための処理												
	const format = (str, ...args) => {
		for (const [i, arg] of args.entries()) {
			const regExp = new RegExp(`\\{${i}\\}`, 'g')
			str = str.replace(regExp, arg)
		}
		return str
	}

	// React Hook Form を使うための基本設定												
	const { control } = useForm({
		defaultValues: {
			tasks: [],         // システムユーザーリスト
			secondTasks: []    // 一般ユーザーリスト
		}
	});

	// input を動的に増減させるための設定												
	const { fields } = useFieldArray({
		control,
		name: "tasks"
	});

	useFieldArray({
		control,
		name: "secondTasks"
	});

	// 日時フォーマット関数
	const formatDateTime = (dateTime) => {
		if (!dateTime) return '';
		
		const date = new Date(dateTime);
		if (isNaN(date.getTime())) return '';
		
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		const hours = String(date.getHours()).padStart(2, '0');
		const minutes = String(date.getMinutes()).padStart(2, '0');
		
		return `${year}/${month}/${day} ${hours}:${minutes}`;
	};

	useEffect(() => {
		(async () => {
			if (window.localStorage.getItem(['token']) === null) {
				navigate('/')
				return;
			}

			// リダイレクトしてきた場合の値セット										
			let reparams = new URLSearchParams(window.location.search);

			// 各パラメータを取得										
			if (reparams.get('auditName')) {
				formValues.auditName = reparams.get('auditName');
			}
			if (reparams.get('auditCode')) {
				formValues.auditCode = reparams.get('auditCode');
			}
			if (reparams.get('orgName')) {
				formValues.orgName = reparams.get('orgName');
			}
			if (reparams.get('orgLevel0Code')) {
				formValues.orgLevel0Code = reparams.get('orgLevel0Code');
			}
			if (reparams.get('projectCode')) {
				formValues.projectCode = reparams.get('projectCode');
			}
			if (reparams.get('projName')) {
				formValues.projName = reparams.get('projName');
			}

			// 登録済みスケジュール取得API実行
			const scheListUrl = setURL(API_URL.UPLOADSCHEDULE_SCHEDULELIST);
			const scheListParams = {};
			scheListParams['auditCode'] = auditCode;
			scheListParams['projCode'] = projCode;
			const getScheListParam = String(new URLSearchParams(scheListParams));
			const getScheListApiParam = {
				url: scheListUrl + '?' + getScheListParam,
				sysRole: SYS_ROLE.UPLOAD_SCHEDULE,
				success: getUpScheListSuccess,
				// error: getUpScheListError,
				error: commonError,
				json: upScheduleList,
			}
			await getApi(getScheListApiParam);

			// 共有フォルダ内ファイル一覧取得API実行
			const shareFileListUrl = setURL(API_URL.UPLOADSCHEDULE_SHAREFILELIST);
			const shareFileListParams = {};
			shareFileListParams['auditCode'] = auditCode;
			shareFileListParams['auditName'] = auditName;
			shareFileListParams['orgLevel0Code'] = orgLevel0Code;
			shareFileListParams['orgName'] = orgName;
			shareFileListParams['projCode'] = projCode;
			shareFileListParams['projName'] = projName;
			const getshareFileListParam = String(new URLSearchParams(shareFileListParams));
			const getshareFileListApiParam = {
			  url: shareFileListUrl + '?' + getshareFileListParam,
			  sysRole: SYS_ROLE.UPLOAD_SCHEDULE,
			  success: (response) => {
				getShareFileListSuccess(response);
				setIsLoading(false); // 成功時にローディング終了
			  },
			  error: getShareFileListError,
			  json: shareFileSampleList,
			}
			await getApi(getshareFileListApiParam);

			setIsLoading(false);
		})();
	}, [formValues.auditName, formValues.orgName, formValues.projName]);

	const [isVisible, setIsVisible] = useState(true);

	useEffect(() => {
		if (fields.length !== 0) {
			setIsVisible(true);
		}
		else {
			setIsVisible(false);
		}
	}, [fields]);

	useEffect(() => {
		// ページ読み込み時にフォーカスを外す
		if (document.activeElement && document.activeElement.blur) {
			document.activeElement.blur();
		}
	}, []);

	// 登録済みスケジュール取得成功時の処理
	const getUpScheListSuccess = (scheduleData) => {
		// isSharedUserConfiguredの処理を追加
		setIsSharedUserConfigured(scheduleData.isSharedUserConfigured || false);

		// shareFolderSeverNameを設定
		setShareFolderSeverName(scheduleData.shareFolderSeverName || '');
		
		console.log('=== API Response Debug ===');
    	console.log('Full scheduleData:', scheduleData);

		// scheduleListの処理（scheduleData.scheduleListを使用）
		const newScheduleList = (scheduleData.scheduleList || []).map(item => ({
			selected: false, // 固定値
			scheduleNo: item.scheduleNo, // 引数のscheduleNoをセット
			scheduleName: item.scheduleName, // 引数のscheduleNameをセット
			fileNames: item.fileNames, // 引数のfileNamesをセット
			uploadDateTime: item.upScheduleDate, // 引数のupScheduleDateをセット
			status: item.scheduleStatus, // 引数のscheduleStatusをセット
			notice: item.scheduleNotice,
			information: item.scheduleInformation,
			promptlyFlg: item.schedulePromptlyFlg,
			openDate: item.scheduleOpenDate,
			noSendFlg: item.scheduleNoSendFlg,
			//filePeriod: item.scheduleFilePeriod || '90' // ★ 追加（APIのプロパティ名に合わせる）
			filePeriod: item.scheduleFilePeriod
		}));
		
		console.log('Final scheduleList:', newScheduleList);

		setScheduleList(newScheduleList);
	};

	/**
	 * アップロード日時の日付入力時の処理
	 * @param {string} date 入力した日付
	 */
	const inputUploadDate = (date) => {
		const option = { year: 'numeric', month: '2-digit', day: '2-digit' };
		const today = new Date().toLocaleDateString('ja-JP', option);
		
		if (date === '') {
			setUploadDate(null);
			setUploadDateFormatErrFlg(false);
			setUploadDatePastErrFlg(false);
		} else if (!(moment(date, 'yyyy/MM/DD', true).isValid())) {
			setUploadDate(moment(date, 'yyyy/MM/DD'));
			setUploadDateFormatErrFlg(true);
			setUploadDatePastErrFlg(false);
		} else if (today <= moment(date, 'yyyy/MM/DD', true)._d.toLocaleDateString('ja-JP', option)) {
			setUploadDate(moment(date, 'yyyy/MM/DD'));
			setUploadDateFormatErrFlg(false);
			setUploadDatePastErrFlg(false);
		} else {
			setUploadDate(moment(date, 'yyyy/MM/DD'));
			setUploadDateFormatErrFlg(false);
			setUploadDatePastErrFlg(true);
		}
	};

	/**
	 * アップロード日時の時刻入力時の処理
	 * @param {string} time 入力した時刻
	 */
	const inputUploadTime = (time) => {
		setUploadTime(time);
		
		// AM/PM形式と24時間形式の両方をサポート
		const isValidTime = moment(time, ['h:mm A', 'hh:mm A', 'H:mm', 'HH:mm'], true).isValid();
		
		if (time === '' || isValidTime) {
			setUploadTimeFormatErrFlg(false);
		} else {
			setUploadTimeFormatErrFlg(true);
		}
	};

	// 登録時のバリデーション
	const validateUploadDateTime = () => {
		if (!uploadDate || uploadTime === '') {
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			setDialogOpen(true);
			setDialogContent(t('message.1007021')); // 日付と時刻を入力してください
			return false;
		}
		
		if (uploadDateFormatErrFlg || uploadDatePastErrFlg || uploadTimeFormatErrFlg) {
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			setDialogOpen(true);
			setDialogContent('正しい日付と時刻を入力してください');
			return false;
		}

		const currentDateTime = new Date();

		// アップロード日時のチェック
		if (uploadDate && uploadTime) {
			const uploadDateTime = new Date(uploadDate);
			
			// 時刻の解析を修正
			const timeStr = uploadTime.trim();
			let hours, minutes;
			
			// AM/PM形式かどうかをチェック
			if (timeStr.includes('AM') || timeStr.includes('PM')) {
				// 12時間形式の場合
				const timeMoment = moment(timeStr, ['h:mm A', 'hh:mm A'], true);
				if (timeMoment.isValid()) {
					hours = timeMoment.hours(); // 24時間形式に変換
					minutes = timeMoment.minutes();
				} else {
					console.error('Invalid time format:', timeStr);
					return false;
				}
			} else {
				// 24時間形式の場合
				const timeParts = timeStr.split(':');
				hours = parseInt(timeParts[0], 10);
				minutes = parseInt(timeParts[1], 10);
			}
			
			uploadDateTime.setHours(hours, minutes, 0, 0);
			console.log('uploadDateTime:', uploadDateTime);
			
			// 現在時刻との比較
			if (uploadDateTime <= currentDateTime) {
				const message = "アップロード日時に" + t('message.1001300');
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				setDialogOpen(true);
				setDialogContent(message);
				return false;
			}

			// 公開日時がアップロード日時より前かチェック
			if (formValues.promptyFlg === PROMPTLY_FLG.PUBLISH_SELECT_DATE && openDate && openTime) {
				const openDateTime = new Date(openDate);
				
				const openTimeStr = openTime.trim();
				let openHours, openMinutes;
				
				if (openTimeStr.includes('AM') || openTimeStr.includes('PM')) {
					const openTimeMoment = moment(openTimeStr, ['h:mm A', 'hh:mm A'], true);
					if (openTimeMoment.isValid()) {
						openHours = openTimeMoment.hours();
						openMinutes = openTimeMoment.minutes();
					} else {
						return false;
					}
				} else {
					const openTimeParts = openTimeStr.split(':');
					openHours = parseInt(openTimeParts[0], 10);
					openMinutes = parseInt(openTimeParts[1], 10);
				}
				
				openDateTime.setHours(openHours, openMinutes, 0, 0);
				
				// 公開日時がアップロード日時より前の場合
				if (openDateTime < uploadDateTime) {
					const message = t('message.1007022');
					setDialogStatus(DIALOG_STATUS.OK_DIALOG);
					setDialogOpen(true);
					setDialogContent(message);
					return false;
				}
			}
		}

		// 公開日時のチェック（選択日時で公開の場合）
		if (formValues.promptyFlg === PROMPTLY_FLG.PUBLISH_SELECT_DATE && openDate && openTime) {
			const openDateTime = new Date(openDate);
			
			const openTimeStr = openTime.trim();
			let hours, minutes;
			
			// AM/PM形式の処理
			if (openTimeStr.includes('AM') || openTimeStr.includes('PM')) {
				const timeMoment = moment(openTimeStr, ['h:mm A', 'hh:mm A'], true);
				if (timeMoment.isValid()) {
					hours = timeMoment.hours();
					minutes = timeMoment.minutes();
				} else {
					console.error('Invalid time format:', openTimeStr);
					return false;
				}
			} else {
				const timeParts = openTimeStr.split(':');
				hours = parseInt(timeParts[0], 10);
				minutes = parseInt(timeParts[1], 10);
			}
			
			openDateTime.setHours(hours, minutes, 0, 0);
			
			if (openDateTime <= currentDateTime) {
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				const message = "公開日時は" + t('message.1001300');
				setConfirmDialogOpen(true);
				setConfirmDialogContent(message);
				return false;
			}
		}
		
		return true;
	};

	/**
	 * 公開日時で即時公開を選択時の処理
	 */
	const selectPublishImmediately = () => {
		setOpenDate(null);
		setOpenTime('');
		setFormValues(prev => ({ 
			...prev, 
			promptyFlg: PROMPTLY_FLG.PUBLISH_IMMEDIATELY, 
			openDisplayDate: null 
		}));
		clearOpenDateErrFlg();
		setOpenTimeFormatErrFlg(false);
	};

	/**
	 * 公開日時の日付入力時の処理
	 * @param {string} date 入力した日付
	 */
	const inputDate = (date) => {
		const option = { year: 'numeric', month: '2-digit', day: '2-digit' };
		const today = new Date().toLocaleDateString('ja-JP', option);
		if (date === '') {
			setOpenDate(null);
			setFormValues(prev => ({ ...prev, openDisplayDate: null }));
			clearOpenDateErrFlg();
		} else if (!(moment(date, 'yyyy/MM/DD', true).isValid())) {
			setOpenDate(moment(date, 'yyyy/MM/DD'));
			setFormValues(prev => ({ ...prev, openDisplayDate: null }));
			setOpenDateFormatErrFlg(true);
			setOpenDatePastErrFlg(false);
		} else if (today <= moment(date, 'yyyy/MM/DD', true)._d.toLocaleDateString('ja-JP', option)) {
			setOpenDate(moment(date, 'yyyy/MM/DD'));
			setFormValues(prev => ({ ...prev, openDisplayDate: moment(date, 'yyyy/MM/DD') }));
			clearOpenDateErrFlg();
		} else {
			setOpenDate(moment(date, 'yyyy/MM/DD'));
			setFormValues(prev => ({ ...prev, openDisplayDate: moment(date, 'yyyy/MM/DD') }));
			setOpenDateFormatErrFlg(false);
			setOpenDatePastErrFlg(true);
		}
	};

	/**
	 * 公開日時の時刻入力時の処理
	 * @param {string} time 入力した時刻
	 */
	const inputTime = (time) => {
		setOpenTime(time);
		setFormValues(prev => ({ ...prev, openTime: time }));
		
		// AM/PM形式と24時間形式の両方をサポート
		const isValidTime = moment(time, ['h:mm A', 'hh:mm A', 'H:mm', 'HH:mm'], true).isValid();
		
		if (time === '' || isValidTime) {
			setOpenTimeFormatErrFlg(false);
		} else {
			setOpenTimeFormatErrFlg(true);
		}
	};

	// エラーフラグの状態
	const [openDateFormatErrFlg, setOpenDateFormatErrFlg] = useState(false);
	const [openDatePastErrFlg, setOpenDatePastErrFlg] = useState(false);
	const [openTimeFormatErrFlg, setOpenTimeFormatErrFlg] = useState(false);
	const [openDateBeforeUploadErrFlg, setOpenDateBeforeUploadErrFlg] = useState(false);

	/**
	 * 公開日のエラーフラグをfalseに設定する処理
	 */
	const clearOpenDateErrFlg = () => {
		setOpenDateFormatErrFlg(false);
		setOpenDatePastErrFlg(false);
	};

	// ファイル入力用の参照を作成
	const fileInputRef = useRef(null);

	/**
	 * FileSelectBoxからファイルが選択された時の処理
	 * @param {Array} selectedFiles 選択されたファイルの配列
	 */
	const handleFileSelect = (selectedFiles) => {
		console.log('handleFileSelect called with:', selectedFiles);
		
		if (!selectedFiles || selectedFiles.length === 0) {
			// 何も選択されていない場合
			setFormValues(prev => ({
				...prev,
				fileNames: []
			}));
			return;
		}
		
		// 選択されたファイル名を配列として取得
		const fileNamesArray = selectedFiles.map(file => file.name);
		
		// formValuesを更新
		setFormValues(prev => ({
			...prev,
			fileNames: fileNamesArray
		}));
		
		console.log('Updated fileNames:', fileNamesArray);
	};

	// ブラウズボタンクリックハンドラ
	const handleBrowseClick = () => {
		// 隠しファイル入力をクリック
		fileInputRef.current.click();
	};

	// コンポーネントの先頭で状態を追加
	const [showScheduleForm, setShowScheduleForm] = useState(false);
	const [isResultCheckMode, setIsResultCheckMode] = useState(false);

	// 変更ボタンのクリックハンドラ
	const handleEditClick = () => {
		const selectedSchedule = scheduleList.find(schedule => schedule.selected);
		if (!selectedSchedule) {
			return;
		}
	
		setIsResultCheckMode(false);
	
		// フォームモードで結果確認以外の場合は確認ダイアログを表示
		if (isFormMode && currentFormMode !== 'resultCheck') {
			setPendingAction('edit');
			setDialogStatus(DIALOG_STATUS.FORM_SWITCH_CONFIRM_DIALOG);
			setConfirmDialogOpen(true);
			setConfirmDialogContent(t('message.1007031'));
			return;
		}
		
		executeEditAction(selectedSchedule);
	};

	// 変更処理を別関数に分離
	const executeEditAction = (selectedSchedule) => {
		console.log('=== Edit Action Debug ===');
    	console.log('Selected schedule:', selectedSchedule);
    	console.log('File period from schedule:', selectedSchedule.filePeriod);

		// 結果確認モードを解除
		setIsResultCheckMode(false);

		setFormValues(prev => ({
			...prev,
			scheduleName: selectedSchedule.scheduleName || '',
			notices: selectedSchedule.notice || '',
			information: selectedSchedule.information || '',
			forInsert: false,
			scheduleNo: selectedSchedule.scheduleNo
		}));

		// アップロード日時の処理
		if (selectedSchedule.uploadDateTime) {
			const formattedDate = moment(selectedSchedule.uploadDateTime).format('YYYY/MM/DD');
			const formattedTime = moment(selectedSchedule.uploadDateTime).format('hh:mm A');
			
			const momentDate = moment(formattedDate, 'YYYY/MM/DD');
			setUploadDate(momentDate);
			setUploadTime(formattedTime);
		}

		// 公開日時の処理
		if (selectedSchedule.openDate) {
			const formattedOpenDate = moment(selectedSchedule.openDate).format('YYYY/MM/DD');
			const formattedOpenTime = moment(selectedSchedule.openDate).format('hh:mm A');
			
			const momentOpenDate = moment(formattedOpenDate, 'YYYY/MM/DD');
			setOpenDate(momentOpenDate);
			setOpenTime(formattedOpenTime);
			
			setFormValues(prev => ({
				...prev,
				openDisplayDate: momentOpenDate
			}));
		}

		// promptlyFlgの処理
		if (selectedSchedule.promptlyFlg) {
			setFormValues(prev => ({
				...prev,
				promptyFlg: selectedSchedule.promptlyFlg
			}));
		}

		// ★★★ ファイル保管期間の処理 ★★★
		if (selectedSchedule.filePeriod) {
			setFormValues(prev => ({
				...prev,
				filePeriod: selectedSchedule.filePeriod
			}));
		}

		// ファイル名の処理
		if (selectedSchedule.fileNames && typeof selectedSchedule.fileNames === 'string') {
			const extractedFileNames = extractFileNamesFromText(selectedSchedule.fileNames);
			if (Array.isArray(extractedFileNames) && extractedFileNames.length > 0) {
				const filesWithDefaultStatus = extractedFileNames
					.filter(fileName => fileName && typeof fileName === 'string' && fileName.trim() !== '')
					.map(fileName => ({
						name: fileName.trim(),
						size: '',
						updated: new Date().toLocaleString()
					}));
				setFileList(filesWithDefaultStatus);

				// FileSelectBoxのチェック状態を更新
				const fileNamesForSelection = extractedFileNames
					.filter(fileName => fileName && typeof fileName === 'string' && fileName.trim() !== '')
					.map(fileName => fileName.trim());
            	setSelectedFileNamesFromFolder(fileNamesForSelection);
			}
		}

		setTimeout(() => {
			setIsResultCheckMode(false);
			setShowScheduleForm(true);
			setIsFormMode(true);
			setCurrentFormMode('edit');
		}, 500);
	};

	// 新規追加
	const handleAddClick = () => {
		// 他のフォームモードからの切り替えチェック
		if (isFormMode && currentFormMode !== 'add' && currentFormMode !== 'resultCheck') {
			setPendingAction('add');
			setDialogStatus(DIALOG_STATUS.FORM_SWITCH_CONFIRM_DIALOG);
			setConfirmDialogOpen(true);
			setConfirmDialogContent(t('message.1007031'));
			return;
		}
		
		if (scheduleList && scheduleList.length >= 100) {
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			setDialogOpen(true);
			setDialogContent(t('message.1007040'));
			return;
		}

		// 結果確認モードを解除
		setIsResultCheckMode(false);

		// 日時状態をクリア
		setUploadDate(null);
		setUploadTime('');
		setOpenDate(null);
		setOpenTime('');

		// エラーフラグをクリア
		setUploadDateFormatErrFlg(false);
		setUploadDatePastErrFlg(false);
		setUploadTimeFormatErrFlg(false);
		setOpenDateFormatErrFlg(false);
		setOpenDatePastErrFlg(false);
		setOpenTimeFormatErrFlg(false);
	
		// フォーム値を初期値にリセット
		setFormValues(prev => ({
			...prev,
			forInsert: true,
			scheduleName: '',
			notices: '',
			information: '',
			promptyFlg: '1',
			openDisplayDate: null,
			noSendFlg: '0',
			scheduleNo: '',
			fileNames: []
		}));
	
		// ファイルリストをクリア
		setFileList([]);
		setSelectedFileNamesFromFolder([]);
	
		// フォーム表示
		formValues.forInsert = true;
		// 少し遅延させてからフォームを表示し、ローディングを終了
		setTimeout(() => {
			setShowScheduleForm(true);
			setIsFormMode(true);
			setCurrentFormMode('add');
		}, 500);
	};

	{/* 結果確認ボタンの活性制御用関数 */}
	const isResultCheckButtonEnabled = () => {
		const selectedSchedule = scheduleList.find(item => item.selected);
		if (!selectedSchedule) return false;
		
		// ステータスが2:リトライ待ち、3:実施済み、9:実施済み（エラー）の場合に活性
		const enabledStatuses = ["リトライ待ち", "実施済み", "実施済み（エラー）"];
		return enabledStatuses.includes(selectedSchedule.status);
	};

	// コピーして追加
	const handleCopyAddClick = () => {
		// 他のフォームモードからの切り替えチェック（コピーモードからコピーも含む）
		if (isFormMode && currentFormMode !== 'resultCheck') {
			setPendingAction('copy');
			setDialogStatus(DIALOG_STATUS.FORM_SWITCH_CONFIRM_DIALOG);
			setConfirmDialogOpen(true);
			setConfirmDialogContent(t('message.1007031'));
			return;
		}
		setIsResultCheckMode(false);

		try {
			// 登録スケジュール件数チェック
			if (scheduleList && scheduleList.length >= 100) {
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				setDialogOpen(true);
				setDialogContent(t('message.1007040'));
				return;
			}
			
			if (!Array.isArray(scheduleList)) {
				console.error('scheduleList is not an array:', scheduleList);
				return;
			}
	
			const selectedSchedule = scheduleList.find(schedule => schedule && schedule.selected);
			console.log('=== Copy Action Debug ===');
			console.log('Selected schedule for copy:', selectedSchedule);
			console.log('File period from schedule:', selectedSchedule?.filePeriod);
	
			if (selectedSchedule) {
				// formValuesの更新
				setFormValues(prev => ({
					...prev,
					scheduleName: selectedSchedule.scheduleName || '',
					notices: selectedSchedule.notice || '',
					information: selectedSchedule.information || '',
					forInsert: true
				}));
	
				// 4.アップロード日時の処理
				if (selectedSchedule.uploadDateTime) {
					// 日付部分はYYYY/MM/DD形式、時刻部分はh:mm A形式（AM/PM付き）
					const formattedDate = moment(selectedSchedule.uploadDateTime).format('YYYY/MM/DD');
					const formattedTime = moment(selectedSchedule.uploadDateTime).format('hh:mm A');
					
					const momentDate = moment(formattedDate, 'YYYY/MM/DD');
					
					// 日付と時刻の状態を更新
					setUploadDate(momentDate);
					setUploadTime(formattedTime);
					
					console.log('Set upload date:', momentDate);
					console.log('Set upload time:', formattedTime);
				}
	
				// 7.公開日時の処理
				if (selectedSchedule.openDate) {
					// 日付部分はYYYY/MM/DD形式、時刻部分はh:mm A形式（AM/PM付き）
					const formattedOpenDate = moment(selectedSchedule.openDate).format('YYYY/MM/DD');
					const formattedOpenTime = moment(selectedSchedule.openDate).format('hh:mm A');
				
					const momentOpenDate = moment(formattedOpenDate, 'YYYY/MM/DD');
					
					setOpenDate(momentOpenDate);
					setOpenTime(formattedOpenTime);
				
					setFormValues(prev => ({
						...prev,
						openDisplayDate: momentOpenDate
					}));
					console.log('Set open date:', momentOpenDate);
					console.log('Set open time:', formattedOpenTime); // 追加
				}
	
				// promptlyFlgの処理
				if (selectedSchedule.promptlyFlg) {
					setFormValues(prev => ({
						...prev,
						promptyFlg: selectedSchedule.promptlyFlg
					}));
					console.log('Set promptly flag:', selectedSchedule.promptlyFlg);
				}
	
				// ファイル保管期間の処理
				if (selectedSchedule.filePeriod) {
					setFormValues(prev => ({
						...prev,
						filePeriod: selectedSchedule.filePeriod
					}));
				} 

				// ファイル名の処理は既存のまま
				if (selectedSchedule.fileNames && typeof selectedSchedule.fileNames === 'string') {
					const extractedFileNames = extractFileNamesFromText(selectedSchedule.fileNames);
					console.log('Extracted file names:', extractedFileNames);
					
					if (Array.isArray(extractedFileNames) && extractedFileNames.length > 0) {
						setFileList(prevList => {
							const currentList = Array.isArray(prevList) ? prevList : [];
							
							const newFiles = extractedFileNames
								.filter(fileName => fileName && typeof fileName === 'string' && fileName.trim() !== '')
								.filter(fileName => !currentList.some(file => file && file.name === fileName))
								.map(fileName => ({
									name: fileName.trim(),
									size: '',
									updated: new Date().toLocaleString()
								}));
							
							if (newFiles.length > 0) {
								console.log('Adding files from copy:', newFiles);
								return [...currentList, ...newFiles];
							}
							
							return currentList;
						});
						// FileSelectBoxのチェック状態を更新
						const fileNamesForSelection = extractedFileNames
                        .filter(fileName => fileName && typeof fileName === 'string' && fileName.trim() !== '')
                        .map(fileName => fileName.trim());
                    setSelectedFileNamesFromFolder(fileNamesForSelection);
					}
				}
				
				setTimeout(() => {
					setShowScheduleForm(true);
					setIsFormMode(true);
					setCurrentFormMode('copy');
				}, 500);
			}
		} catch (error) {
			console.error('Error in handleCopyAddClick:', error);
		}
	};	

	// 結果確認ボタンのクリックハンドラー
	const handleResultCheckClick = async () => {
		// 結果確認モード中は確認ダイアログを表示せずに直接実行
		if (isResultCheckMode) {
			executeResultCheck();
			return;
		}

		// フォームモードのチェック（結果確認モード以外）
		if (isFormMode && currentFormMode !== 'resultCheck') {
			setPendingAction('resultCheck');
			setDialogStatus(DIALOG_STATUS.FORM_SWITCH_CONFIRM_DIALOG);
			setConfirmDialogOpen(true);
			setConfirmDialogContent(t('message.1007031'));
			return;
		}
		
		// フォームモードでない場合は直接結果確認処理を実行
		executeResultCheck();
	};

	// 結果確認の実際の処理を別関数に分離
	const executeResultCheck = async () => {
		const selectedSchedule = scheduleList.find(schedule => schedule.selected);
		if (!selectedSchedule) {
			return;
		}

		const resultCheckUrl = setURL(API_URL.UPLOADSCHEDULE_RESULT);
		const resultCheckParams = {};
		resultCheckParams['auditCode'] = formValues.auditCode;
		resultCheckParams['projCode'] = formValues.projectCode;
		resultCheckParams['scheduleNo'] = selectedSchedule.scheduleNo;
		const getResultCheckParam = String(new URLSearchParams(resultCheckParams));
		
		const getResultCheckApiParam = {
			url: resultCheckUrl + '?' + getResultCheckParam,
			sysRole: SYS_ROLE.UPLOAD_SCHEDULE,
			success: (resultData) => {
				// API成功時の処理
				console.log('Result check API success:', resultData);
					
				// 既存のフォーム設定処理を実行
				setFormValues(prev => ({
					...prev,
					scheduleName: selectedSchedule.scheduleName || '',
					notices: selectedSchedule.notice || '',
					information: selectedSchedule.information || '',
					forInsert: false // 結果確認なので編集モード
				}));

				// 4.アップロード日時の処理
				if (selectedSchedule.uploadDateTime) {
					const formattedDateTime = moment(selectedSchedule.uploadDateTime).format('YYYY/MM/DD HH:mm');
					const dateStr = formattedDateTime.substring(0, 10);
					const timeStr = formattedDateTime.substring(11, 16);
					
					const momentDate = moment(dateStr, 'YYYY/MM/DD');
					
					setUploadDate(momentDate);
					setUploadTime(timeStr);
				}

				// 7.公開日時の処理
				if (selectedSchedule.openDate) {
					const formattedOpenDateTime = moment(selectedSchedule.openDate).format('YYYY/MM/DD HH:mm');
					const openDateStr = formattedOpenDateTime.substring(0, 10);
					const openTimeStr = formattedOpenDateTime.substring(11, 16);
				
					const momentOpenDate = moment(openDateStr, 'YYYY/MM/DD');
					
					setOpenDate(momentOpenDate);
					setOpenTime(openTimeStr);
				
					setFormValues(prev => ({
						...prev,
						openDate: momentOpenDate,
						openDisplayDate: momentOpenDate,
						openTime: openTimeStr
					}));
				}

				// promptlyFlgの処理
				if (selectedSchedule.promptlyFlg) {
					setFormValues(prev => ({
						...prev,
						promptyFlg: selectedSchedule.promptlyFlg
					}));
				}

				// APIレスポンスからファイル情報を処理
				if (resultData && Array.isArray(resultData)) {
					const filesWithStatus = resultData.map(fileInfo => ({
						name: fileInfo.fileName || '',
						size: '',
						updated: new Date().toLocaleString(),
						status: fileInfo.response || '不明' // responseをstatusとして設定
					}));
					
					setFileList(filesWithStatus);
					console.log('Files with status from API:', filesWithStatus);
				} else if (selectedSchedule.fileNames && typeof selectedSchedule.fileNames === 'string') {
					// フォールバック処理（APIレスポンスがない場合）
					const extractedFileNames = extractFileNamesFromText(selectedSchedule.fileNames);
					console.log('Extracted file names:', extractedFileNames);
					
					if (Array.isArray(extractedFileNames) && extractedFileNames.length > 0) {
						const filesWithDefaultStatus = extractedFileNames
							.filter(fileName => fileName && typeof fileName === 'string' && fileName.trim() !== '')
							.map(fileName => ({
								name: fileName.trim(),
								size: '',
								updated: new Date().toLocaleString(),
								status: '正常' // デフォルトステータス
							}));
						
						setFileList(filesWithDefaultStatus);
					}
				}
				
				setShowScheduleForm(true);
				setIsResultCheckMode(true);
				setIsFormMode(true);
            	setCurrentFormMode('resultCheck');
			},
			error: (error) => {
				const detailErrorMessage = '結果確認処理でエラーが発生しました。\n(An error occurred during the result check process.)';
				commonError(error, detailErrorMessage);
				redirectToLogin();
			},
			json: upScheduleResult
		};
		
		getApi(getResultCheckApiParam);
	};

	// チェック状態を解除し、メッセージを消す
	const cancelEdit = () => {
		setIsFormMode(false);
		setCurrentFormMode(null);
		setShowScheduleForm(false);
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setConfirmDialogOpen(false);
		const newScheduleList = scheduleList.map(schedule => ({
			...schedule,
			selected: false
		}));
		setScheduleList(newScheduleList);
	}

	const [pendingSwitchIndex, setPendingSwitchIndex] = useState(null);

	// 確認ダイアログの処理部分
	const handleConfirmDialog = () => {
		if (dialogStatus === DIALOG_STATUS.FORM_SWITCH_CONFIRM_DIALOG) {
			setDialogStatus(DIALOG_STATUS.NO_DIALOG);
	        setConfirmDialogOpen(false);

			// フォームモードを解除
			setIsResultCheckMode(false);
			setIsFormMode(false);
			setCurrentFormMode(null);
			setShowScheduleForm(false);
			
			// 保留中のアクションを実行
			switch (pendingAction) {
				case 'add':
					// 新規追加の処理を直接実行
					if (scheduleList && scheduleList.length >= 100) {
						setDialogStatus(DIALOG_STATUS.OK_DIALOG);
						setDialogOpen(true);
						setDialogContent(t('message.1007040'));
						break;
					}
	
					// 状態をクリア
					setUploadDate(null);
					setUploadTime('');
					setOpenDate(null);
					setOpenTime('');
					setUploadDateFormatErrFlg(false);
					setUploadDatePastErrFlg(false);
					setUploadTimeFormatErrFlg(false);
					setOpenDateFormatErrFlg(false);
					setOpenDatePastErrFlg(false);
					setOpenTimeFormatErrFlg(false);
					
					// フォーム値をクリア
					setFormValues(prev => ({
						...prev,
						scheduleName: '',
						notices: '',
						information: '',
						forInsert: true,
						openDisplayDate: null,
						promptyFlg: '1'
					}));
					
					setFileList([]);
					setSelectedFileNamesFromFolder([]);
					
					// フォームモードを設定してから表示
					setTimeout(() => {
						setIsResultCheckMode(false);
						setIsFormMode(true);
						setCurrentFormMode('add');
						setShowScheduleForm(true);
					}, 100);
					break;
					
					case 'edit':
						// 変更の処理を直接実行
						const selectedScheduleForEdit = scheduleList.find(schedule => schedule.selected);
						if (selectedScheduleForEdit) {
							setFormValues(prev => ({
								...prev,
								scheduleName: selectedScheduleForEdit.scheduleName || '',
								notices: selectedScheduleForEdit.notice || '',
								information: selectedScheduleForEdit.information || '',
								forInsert: false
							}));
							
							// アップロード日時の処理
							if (selectedScheduleForEdit.uploadDateTime) {
								const formattedDateTime = moment(selectedScheduleForEdit.uploadDateTime).format('YYYY/MM/DD HH:mm');
								const dateStr = formattedDateTime.substring(0, 10);
								const timeStr = formattedDateTime.substring(11, 16);
								
								const momentDate = moment(dateStr, 'YYYY/MM/DD');
								setUploadDate(momentDate);
								setUploadTime(timeStr);
							}
							
							// 公開日時の処理
							if (selectedScheduleForEdit.openDate) {
								const formattedOpenDateTime = moment(selectedScheduleForEdit.openDate).format('YYYY/MM/DD HH:mm');
								const openDateStr = formattedOpenDateTime.substring(0, 10);
								const openTimeStr = formattedOpenDateTime.substring(11, 16);
								
								const momentOpenDate = moment(openDateStr, 'YYYY/MM/DD');
								setOpenDate(momentOpenDate);
								setOpenTime(openTimeStr);
								
								setFormValues(prev => ({
									...prev,
									openDisplayDate: momentOpenDate
								}));
							}
							
							// promptlyFlgの処理
							if (selectedScheduleForEdit.promptlyFlg) {
								setFormValues(prev => ({
									...prev,
									promptyFlg: selectedScheduleForEdit.promptlyFlg
								}));
							}
							
							// ✅ ファイル保管期間の処理を追加
							if (selectedScheduleForEdit.filePeriod) {
								setFormValues(prev => ({
									...prev,
									filePeriod: selectedScheduleForEdit.filePeriod
								}));
							}
							
							// ファイル名の処理
							if (selectedScheduleForEdit.fileNames && typeof selectedScheduleForEdit.fileNames === 'string') {
								const extractedFileNames = extractFileNamesFromText(selectedScheduleForEdit.fileNames);
								if (Array.isArray(extractedFileNames) && extractedFileNames.length > 0) {
									const filesWithDefaultStatus = extractedFileNames
										.filter(fileName => fileName && typeof fileName === 'string' && fileName.trim() !== '')
										.map(fileName => ({
											name: fileName.trim(),
											size: '',
											updated: new Date().toLocaleString()
										}));
									setFileList(filesWithDefaultStatus);
									
									// ★追加: FileSelectBoxのチェック状態を更新
									const fileNamesForSelection = extractedFileNames
										.filter(fileName => fileName && typeof fileName === 'string' && fileName.trim() !== '')
										.map(fileName => fileName.trim());
									setSelectedFileNamesFromFolder(fileNamesForSelection);
								}
							}
							
							setShowScheduleForm(true);
						}
						break;					
					
						case 'copy':
							// コピーして追加の処理
							const selectedScheduleForCopy = scheduleList.find(schedule => schedule.selected);
							if (selectedScheduleForCopy) {
								// 100件チェックを追加
								if (scheduleList && scheduleList.length >= 100) {
									setDialogStatus(DIALOG_STATUS.OK_DIALOG);
									setDialogOpen(true);
									setDialogContent(t('message.1007040'));
									break;
								}
								
								// 状態をクリア
								setIsResultCheckMode(false);
								setUploadDate(null);
								setUploadTime('');
								setOpenDate(null);
								setOpenTime('');
								setUploadDateFormatErrFlg(false);
								setUploadDatePastErrFlg(false);
								setUploadTimeFormatErrFlg(false);
								setOpenDateFormatErrFlg(false);
								setOpenDatePastErrFlg(false);
								setOpenTimeFormatErrFlg(false);
						
								setFormValues(prev => ({
									...prev,
									scheduleName: selectedScheduleForCopy.scheduleName || '',
									notices: selectedScheduleForCopy.notice || '',
									information: selectedScheduleForCopy.information || '',
									forInsert: true
								}));
						
								// 日時処理...
								if (selectedScheduleForCopy.uploadDateTime) {
									const formattedDate = moment(selectedScheduleForCopy.uploadDateTime).format('YYYY/MM/DD');
									const formattedTime = moment(selectedScheduleForCopy.uploadDateTime).format('hh:mm A');
									
									const momentDate = moment(formattedDate, 'YYYY/MM/DD');
									setUploadDate(momentDate);
									setUploadTime(formattedTime);
								}
						
								if (selectedScheduleForCopy.openDate) {
									const formattedOpenDate = moment(selectedScheduleForCopy.openDate).format('YYYY/MM/DD');
									const formattedOpenTime = moment(selectedScheduleForCopy.openDate).format('hh:mm A');
								
									const momentOpenDate = moment(formattedOpenDate, 'YYYY/MM/DD');
									setOpenDate(momentOpenDate);
									setOpenTime(formattedOpenTime);
								
									setFormValues(prev => ({
										...prev,
										openDisplayDate: momentOpenDate
									}));
								}
						
								if (selectedScheduleForCopy.promptlyFlg) {
									setFormValues(prev => ({
										...prev,
										promptyFlg: selectedScheduleForCopy.promptlyFlg
									}));
								}
						
								 // ★★★ ファイル保管期間 ★★★
								 if (selectedScheduleForCopy.filePeriod) {
									setFormValues(prev => ({
										...prev,
										filePeriod: selectedScheduleForCopy.filePeriod
									}));
								}

								// ファイル処理...
								if (selectedScheduleForCopy.fileNames && typeof selectedScheduleForCopy.fileNames === 'string') {
									const extractedFileNames = extractFileNamesFromText(selectedScheduleForCopy.fileNames);
									if (Array.isArray(extractedFileNames) && extractedFileNames.length > 0) {
										const newFiles = extractedFileNames
											.filter(fileName => fileName && typeof fileName === 'string' && fileName.trim() !== '')
											.map(fileName => ({
												name: fileName.trim(),
												size: '',
												updated: new Date().toLocaleString()
											}));
										setFileList(newFiles);
										
										// FileSelectBoxのチェック状態を更新
										const fileNamesForSelection = extractedFileNames
											.filter(fileName => fileName && typeof fileName === 'string' && fileName.trim() !== '')
											.map(fileName => fileName.trim());
										setSelectedFileNamesFromFolder(fileNamesForSelection);
									}
								}
								
								// フォームモードを設定してから表示
								setTimeout(() => {
									setIsResultCheckMode(false);
									setIsFormMode(true);
									setCurrentFormMode('copy');
									setShowScheduleForm(true);
								}, 100);
							}
							break;						
					
				case 'delete':
					const selectedScheduleForDelete = scheduleList.find(item => item.selected);
					if (selectedScheduleForDelete) {
						setDialogStatus(DIALOG_STATUS.DELETE_CONFIRM_DIALOG);
						const message = t('message.1007000');
						setConfirmDialogOpen(true);
						setConfirmDialogContent(message);
						return;
					}
					break;
					
				case 'resultCheck':
					executeResultCheck();
					break;
					
				default:
					break;
			}
			
			setPendingAction(null);
		} else if (dialogStatus === DIALOG_STATUS.COPY_SWITCH_CONFIRM_DIALOG) {
			// フォームモードを解除
			setIsFormMode(false);
			setCurrentFormMode(null);
        	setShowScheduleForm(false);
			
			// 保留中のアクションを実行
			switch (pendingAction) {
				case 'add':
					// 新規追加の処理を直接実行
					if (scheduleList && scheduleList.length >= 100) {
						setDialogStatus(DIALOG_STATUS.OK_DIALOG);
						setDialogOpen(true);
						setDialogContent(t('message.1007040'));
						break;
					}

					// 日時をクリア
					setUploadDate(null);
					setUploadTime('');
					setOpenDate(null);
					setOpenTime('');

					// エラーフラグもクリア
					setUploadDateFormatErrFlg(false);
					setUploadDatePastErrFlg(false);
					setUploadTimeFormatErrFlg(false);
					setOpenDateFormatErrFlg(false);
					setOpenDatePastErrFlg(false);
					setOpenTimeFormatErrFlg(false);
					
					// フォーム値をクリア
					setFormValues(prev => ({
						...prev,
						scheduleName: '',
						notices: '',
						information: '',
						forInsert: true,
						openDisplayDate: null,
						promptyFlg: '1'
					}));
					
					// ファイルリストをクリア
					setFileList([]);
					setSelectedFileNamesFromFolder([]);
					
					// 少し遅延させてからフォームを表示
					setTimeout(() => {
						setShowScheduleForm(true);
					}, 50);
					break;
				case 'edit':
					// 変更の処理を直接実行
					const selectedScheduleForEdit = scheduleList.find(schedule => schedule.selected);
					if (selectedScheduleForEdit) {
						setFormValues(prev => ({
							...prev,
							scheduleName: selectedScheduleForEdit.scheduleName || '',
							notices: selectedScheduleForEdit.notice || '',
							information: selectedScheduleForEdit.information || '',
							forInsert: false
						}));
						
						// アップロード日時の処理
						if (selectedScheduleForEdit.uploadDateTime) {
							const formattedDateTime = moment(selectedScheduleForEdit.uploadDateTime).format('YYYY/MM/DD HH:mm');
							const dateStr = formattedDateTime.substring(0, 10);
							const timeStr = formattedDateTime.substring(11, 16);
							
							const momentDate = moment(dateStr, 'YYYY/MM/DD');
							setUploadDate(momentDate);
							setUploadTime(timeStr);
						}
						
						// 公開日時の処理
						if (selectedScheduleForEdit.openDate) {
							const formattedOpenDateTime = moment(selectedScheduleForEdit.openDate).format('YYYY/MM/DD HH:mm');
							const openDateStr = formattedOpenDateTime.substring(0, 10);
							const openTimeStr = formattedOpenDateTime.substring(11, 16);
							
							const momentOpenDate = moment(openDateStr, 'YYYY/MM/DD');
							setOpenDate(momentOpenDate);
							setOpenTime(openTimeStr);
							
							setFormValues(prev => ({
								...prev,
								openDisplayDate: momentOpenDate
							}));
						}
						
						// promptlyFlgの処理
						if (selectedScheduleForEdit.promptlyFlg) {
							setFormValues(prev => ({
								...prev,
								promptyFlg: selectedScheduleForEdit.promptlyFlg
							}));
						}
						
						// ファイル名の処理
						if (selectedScheduleForEdit.fileNames && typeof selectedScheduleForEdit.fileNames === 'string') {
							const extractedFileNames = extractFileNamesFromText(selectedScheduleForEdit.fileNames);
							if (Array.isArray(extractedFileNames) && extractedFileNames.length > 0) {
								const filesWithDefaultStatus = extractedFileNames
									.filter(fileName => fileName && typeof fileName === 'string' && fileName.trim() !== '')
									.map(fileName => ({
										name: fileName.trim(),
										size: '',
										updated: new Date().toLocaleString()
									}));
								setFileList(filesWithDefaultStatus);
							}
						}
						
						setShowScheduleForm(true);
					}
					break;
				case 'delete':
					// 削除の処理を直接実行
					const selectedScheduleForDelete = scheduleList.find(item => item.selected);
					if (selectedScheduleForDelete) {
						setDialogStatus(DIALOG_STATUS.DELETE_CONFIRM_DIALOG);
						const message = t('message.1007000');
						setConfirmDialogOpen(true);
						setConfirmDialogContent(message);
						return; // ここでreturnして、下のsetConfirmDialogOpen(false)を実行しない
					}
					break;
				case 'resultCheck':
					// handleResultCheckClickを再帰的に呼び出すのではなく、
					// 結果確認の処理を直接実行する
					const selectedScheduleForResult = scheduleList.find(schedule => schedule.selected);
					if (selectedScheduleForResult) {
						// 結果確認API実行
						const resultCheckUrl = setURL(API_URL.UPLOADSCHEDULE_RESULT);
						const resultCheckParams = {};
						resultCheckParams['auditCode'] = formValues.auditCode;
						resultCheckParams['projCode'] = formValues.projectCode;
						resultCheckParams['scheduleNo'] = selectedScheduleForResult.scheduleNo;
						const getResultCheckParam = String(new URLSearchParams(resultCheckParams));
						
						const getResultCheckApiParam = {
							url: resultCheckUrl + '?' + getResultCheckParam,
							sysRole: SYS_ROLE.UPLOAD_SCHEDULE,
							success: (resultData) => {
								// フォーム設定処理
								setFormValues(prev => ({
									...prev,
									scheduleName: selectedScheduleForResult.scheduleName || '',
									notices: selectedScheduleForResult.notice || '',
									information: selectedScheduleForResult.information || '',
									forInsert: false
								}));
				
								// アップロード日時の処理
								if (selectedScheduleForResult.uploadDateTime) {
									const formattedDateTime = moment(selectedScheduleForResult.uploadDateTime).format('YYYY/MM/DD HH:mm');
									const dateStr = formattedDateTime.substring(0, 10);
									const timeStr = formattedDateTime.substring(11, 16);
									
									const momentDate = moment(dateStr, 'YYYY/MM/DD');
									setUploadDate(momentDate);
									setUploadTime(timeStr);
								}
				
								// 公開日時の処理
								if (selectedScheduleForResult.openDate) {
									const formattedOpenDateTime = moment(selectedScheduleForResult.openDate).format('YYYY/MM/DD HH:mm');
									const openDateStr = formattedOpenDateTime.substring(0, 10);
									const openTimeStr = formattedOpenDateTime.substring(11, 16);
								
									const momentOpenDate = moment(openDateStr, 'YYYY/MM/DD');
									setOpenDate(momentOpenDate);
									setOpenTime(openTimeStr);
								
									setFormValues(prev => ({
										...prev,
										openDisplayDate: momentOpenDate
									}));
								}
				
								// promptlyFlgの処理
								if (selectedScheduleForResult.promptlyFlg) {
									setFormValues(prev => ({
										...prev,
										promptyFlg: selectedScheduleForResult.promptlyFlg
									}));
								}
				
								// ファイル処理
								if (resultData && Array.isArray(resultData)) {
									const filesWithStatus = resultData.map(fileInfo => ({
										name: fileInfo.fileName || '',
										size: '',
										updated: new Date().toLocaleString(),
										status: fileInfo.response || '不明'
									}));
									setFileList(filesWithStatus);
								} else if (selectedScheduleForResult.fileNames && typeof selectedScheduleForResult.fileNames === 'string') {
									const extractedFileNames = extractFileNamesFromText(selectedScheduleForResult.fileNames);
									if (Array.isArray(extractedFileNames) && extractedFileNames.length > 0) {
										const filesWithDefaultStatus = extractedFileNames
											.filter(fileName => fileName && typeof fileName === 'string' && fileName.trim() !== '')
											.map(fileName => ({
												name: fileName.trim(),
												size: '',
												updated: new Date().toLocaleString(),
												status: '正常'
											}));
										setFileList(filesWithDefaultStatus);
									}
								}
								
								setShowScheduleForm(true);
								setIsResultCheckMode(true);
							},
							error: (error) => {
								const detailErrorMessage = '結果確認処理でエラーが発生しました。\n(An error occurred during the result check process.)';
								commonError(error, detailErrorMessage);
								redirectToLogin();
							},
							json: upScheduleResult
						};
						
						getApi(getResultCheckApiParam);
					}
					break;					
				default:
					break;
			}
			
			setPendingAction(null);
		} else if (dialogStatus === DIALOG_STATUS.SWITCH_CONFIRM_DIALOG) {
			// 切り替え処理を実行
			const newScheduleList = [...scheduleList];
			newScheduleList.forEach((item) => {
				item.selected = false;
			});
			newScheduleList[pendingSwitchIndex].selected = true;
			setScheduleList(newScheduleList);
			
			// フォームをリセット
			setShowScheduleForm(false);
			setPendingSwitchIndex(null);
		}
		
		setConfirmDialogOpen(false);
	};

	/**
	 * FileSelectBoxからファイルが選択された時の処理
	 * @param {Array} selectedFiles 選択されたファイルの配列
	 */
	const handleFileSelectFromFolder = (selectedFiles) => {
		console.log('handleFileSelectFromFolder called with:', selectedFiles);
		
		// 現在選択されているファイル名を取得
		const newSelectedFileNames = selectedFiles ? selectedFiles.map(file => file.name) : [];
		
		// 前回選択されていたが今回選択されていないファイルを特定
		const deselectedFiles = selectedFileNamesFromFolder.filter(
			fileName => !newSelectedFileNames.includes(fileName)
		);
		
		// 新しく選択されたファイルを特定
		const newlySelectedFiles = newSelectedFileNames.filter(
			fileName => !selectedFileNamesFromFolder.includes(fileName)
		);
		
		// 選択状態を更新
		setSelectedFileNamesFromFolder(newSelectedFileNames);
		
		// 3.ファイル名のリストから選択解除されたファイルを削除
		if (deselectedFiles.length > 0) {
			setFileList(prevList => 
				prevList.filter(file => !deselectedFiles.includes(file.name))
			);
			console.log('Removed files from fileList:', deselectedFiles);
		}
		
		// 新しく選択されたファイルを3.ファイル名のリストに追加
		if (newlySelectedFiles.length > 0) {
			const filesToAdd = selectedFiles.filter(file => 
				newlySelectedFiles.includes(file.name)
			);
			addFilesToFileList(filesToAdd);
		}
	};

	/**
	 * 選択されたファイルを3.ファイル名のリストに追加
	 * @param {Array} selectedFiles 選択されたファイルの配列
	 */
	const addFilesToFileList = (selectedFiles) => {
		const newFiles = selectedFiles.map(file => ({ name: file.name }));
		
		// 重複チェック
		const existingFileNames = fileList.map(file => file.name);
		const uniqueNewFiles = newFiles.filter(file => 
			!existingFileNames.includes(file.name) && file.name.trim() !== ''
		);
		
		if (uniqueNewFiles.length > 0) {
			setFileList(prev => [...prev, ...uniqueNewFiles]);
			console.log('Added files to fileList:', uniqueNewFiles);
		}
	};

	/**
	 * ファイルリストからファイルを削除する処理
	 * @param {number} index 削除するファイルのインデックス
	 */
	const handleDeleteFile = (index) => {
		console.log('handleDeleteFile called with index:', index);
		
		const fileToDelete = fileList[index];
		if (!fileToDelete) {
			console.error('File not found at index:', index);
			return;
		}
		
		console.log('Deleting file:', fileToDelete.name);
		
		// 3.ファイル名のリストから削除
		const newFileList = fileList.filter((_, i) => i !== index);
		setFileList(newFileList);
		
		// フォルダファイルの場合、選択状態からも削除
		const isFromFolder = selectedFileNamesFromFolder.includes(fileToDelete.name);
		if (isFromFolder) {
			setSelectedFileNamesFromFolder(prevSelected => 
				prevSelected.filter(fileName => fileName !== fileToDelete.name)
			);
		}
	};

	/**
	 * 共有フォルダのファイル選択状態を変更
	 * @param {number} index ファイルのインデックス
	 * @param {boolean} checked チェック状態
	 */
	const handleFolderFileCheck = (index, checked) => {
		console.log(`File ${index} checked: ${checked}`);
		
		const updatedFolderFiles = [...folderFiles];
		updatedFolderFiles[index].selected = checked;
		setFolderFiles(updatedFolderFiles);
		
		if (checked) {
			// チェックされた場合、ファイル名リストに追加
			const fileToAdd = { name: updatedFolderFiles[index].name };
			
			// 重複チェック
			const isDuplicate = fileList.some(file => file.name === fileToAdd.name);
			
			if (!isDuplicate) {
				setFileList(prevList => {
					const newList = [...prevList, fileToAdd];
					console.log('File added to list:', fileToAdd.name);
					return newList;
				});
			}
		} else {
			// チェックが外された場合、ファイル名リストから削除
			const fileNameToRemove = updatedFolderFiles[index].name;
			setFileList(prevList => {
				const newList = prevList.filter(file => file.name !== fileNameToRemove);
				console.log('File removed from list:', fileNameToRemove);
				return newList;
			});
		}
	};

	/**
	 * コピーされたテキストからファイル名を抽出する（カンマ区切り）
	 * @param {string} text コピーされたテキスト
	 * @returns {Array} 抽出されたファイル名の配列
	 */
	const extractFileNamesFromText = (text) => {
		if (!text) return [];
		
		// カンマで分割してファイル名を抽出
		const items = text.split(',');
		const fileNames = [];
		
		items.forEach(item => {
			const trimmedItem = item.trim();
			
			// 空文字をスキップ
			if (!trimmedItem) return;
			
			// パスからファイル名のみを抽出
			const fileName = trimmedItem.split(/[\\\/]/).pop();
			
			// 重複チェックして追加
			if (fileName && !fileNames.includes(fileName)) {
				fileNames.push(fileName);
			}
		});
		
		return fileNames;
	};

	/**
	 * スケジュール名の重複チェック
	 * @param {string} scheduleName チェックするスケジュール名
	 * @returns {boolean} 重複している場合はtrue
	 */
	const isDuplicateScheduleName = (scheduleName) => {
		if (!scheduleName || scheduleName.trim() === '') {
			return false;
		}
		
		// 編集モードの場合は、現在編集中のスケジュール以外との重複をチェック
		if (!formValues.forInsert && formValues.scheduleNo) {
			return scheduleList.some(schedule => 
				schedule.scheduleName === scheduleName.trim() && 
				schedule.scheduleNo !== formValues.scheduleNo
			);
		}
		
		// 新規追加モードの場合は、全てのスケジュールとの重複をチェック
		return scheduleList.some(schedule => 
			schedule.scheduleName === scheduleName.trim()
		);
	};

	/**
	 * 公開日時がアップロード日時より前かチェックする関数
	 */
	const checkOpenDateBeforeUpload = () => {
		if (!uploadDate || !uploadTime || !openDate || !openTime) {
			setOpenDateBeforeUploadErrFlg(false);
			return;
		}

		if (formValues.promptyFlg !== PROMPTLY_FLG.PUBLISH_SELECT_DATE) {
			setOpenDateBeforeUploadErrFlg(false);
			return;
		}

		try {
			// アップロード日時を作成
			const uploadDateTime = new Date(uploadDate);
			const timeStr = uploadTime.trim();
			let hours, minutes;
			
			if (timeStr.includes('AM') || timeStr.includes('PM')) {
				const timeMoment = moment(timeStr, ['h:mm A', 'hh:mm A'], true);
				if (timeMoment.isValid()) {
					hours = timeMoment.hours();
					minutes = timeMoment.minutes();
				} else {
					setOpenDateBeforeUploadErrFlg(false);
					return;
				}
			} else {
				const timeParts = timeStr.split(':');
				hours = parseInt(timeParts[0], 10);
				minutes = parseInt(timeParts[1], 10);
			}
			uploadDateTime.setHours(hours, minutes, 0, 0);
			
			// 公開日時を作成
			const openDateTime = new Date(openDate);
			const openTimeStr = openTime.trim();
			let openHours, openMinutes;
			
			if (openTimeStr.includes('AM') || openTimeStr.includes('PM')) {
				const openTimeMoment = moment(openTimeStr, ['h:mm A', 'hh:mm A'], true);
				if (openTimeMoment.isValid()) {
					openHours = openTimeMoment.hours();
					openMinutes = openTimeMoment.minutes();
				} else {
					setOpenDateBeforeUploadErrFlg(false);
					return;
				}
			} else {
				const openTimeParts = openTimeStr.split(':');
				openHours = parseInt(openTimeParts[0], 10);
				openMinutes = parseInt(openTimeParts[1], 10);
			}
			openDateTime.setHours(openHours, openMinutes, 0, 0);
			
			// 公開日時がアップロード日時より前の場合
			if (openDateTime < uploadDateTime) {
				setOpenDateBeforeUploadErrFlg(true);
			} else {
				setOpenDateBeforeUploadErrFlg(false);
			}
		} catch (error) {
			console.error('Date comparison error:', error);
			setOpenDateBeforeUploadErrFlg(false);
		}
	};

	/**
	 * 共有フォルダ内ファイル一覧を取得する関数 改善
	 */
	const fetchShareFileList = async () => {
		try {
			const shareFileListUrl = setURL(API_URL.UPLOADSCHEDULE_SHAREFILELIST);
			const shareFileListParams = {};
			shareFileListParams['auditCode'] = formValues.auditCode;
			shareFileListParams['auditName'] = formValues.auditName;
			shareFileListParams['orgLevel0Code'] = formValues.orgLevel0Code;
			shareFileListParams['orgName'] = formValues.orgName;
			shareFileListParams['projCode'] = formValues.projectCode;
			shareFileListParams['projName'] = formValues.projName;
			const getshareFileListParam = String(new URLSearchParams(shareFileListParams));
			const getshareFileListApiParam = {
				url: shareFileListUrl + '?' + getshareFileListParam,
				sysRole: SYS_ROLE.UPLOAD_SCHEDULE,
				success: getShareFileListSuccess,
				error: getShareFileListError,
				json: shareFileSampleList,
			}
			await getApi(getshareFileListApiParam);
		} catch (error) {
			console.error('Failed to fetch share file list:', error);
			getShareFileListError(error);
		}
	};

	/**
	 * リフレッシュボタンクリック時の処理 改善
	 */
	const handleRefreshFileList = async () => {
		console.log('Refreshing shared folder file list...');
		
		try {
			await fetchShareFileList();
			console.log('File list refreshed successfully');
		} catch (error) {
			console.error('Failed to refresh file list:', error);
		}
	};

	/**
	 * CSVダウンロード処理（全スケジュール）
	 */
	const handleDownloadCSV = async () => {
		// スケジュールが存在しない場合はエラー
		if (!scheduleList || scheduleList.length === 0) {
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			setDialogOpen(true);
			setDialogContent('ダウンロードするスケジュールがありません。');
			return;
		}

		try {
			const csvDownloadUrl = setURL(API_URL.UPLOADSCHEDULE_CSV_DOWNLOAD);
			const csvDownloadParams = {};
			csvDownloadParams['auditCode'] = formValues.auditCode;
			csvDownloadParams['projCode'] = formValues.projectCode;
			const getCsvDownloadParam = String(new URLSearchParams(csvDownloadParams));
			
			// APIを呼び出してCSVファイルをダウンロード
			const response = await fetch(csvDownloadUrl + '?' + getCsvDownloadParam, {
				method: 'GET',
				headers: {
					'Authorization': `Bearer ${window.localStorage.getItem('token')}`,
					'Content-Type': 'application/json',
					'Sysrole': SYS_ROLE.UPLOAD_SCHEDULE
				}
			});

			if (!response.ok) {
				throw new Error('CSV download failed');
			}

			// レスポンスからBlobを取得
			const blob = await response.blob();
			
			// ファイル名を生成
			const now = new Date();
			const timestamp = now.toISOString().slice(0, 19).replace(/[:-]/g, '').replace('T', '_');
			const fileName = `スケジュール一覧_${formValues.auditName}_${timestamp}.csv`;

			// File System Access API をサポートしているかチェック
			if ('showSaveFilePicker' in window) {
				try {
					// ファイル保存ダイアログを表示
					const fileHandle = await window.showSaveFilePicker({
						suggestedName: fileName,
						types: [
							{
								description: 'CSV files',
								accept: {
									'text/csv': ['.csv'],
								},
							},
						],
					});
					
					// ファイルに書き込み
					const writable = await fileHandle.createWritable();
					await writable.write(blob);
					await writable.close();
					
					console.log('CSV file saved successfully');
					
					// 成功メッセージを表示
					setDialogStatus(DIALOG_STATUS.OK_DIALOG);
					setDialogOpen(true);
					setDialogContent('ファイルのダウンロードが完了しました。');
					
				} catch (err) {
					// ユーザーがキャンセルした場合やエラーの場合は従来の方法にフォールバック
					if (err.name !== 'AbortError') {
						console.warn('File System Access API failed, falling back to download:', err);
						fallbackDownload(blob, fileName);
						
						// フォールバック時も成功メッセージを表示
						setDialogStatus(DIALOG_STATUS.OK_DIALOG);
						setDialogOpen(true);
						setDialogContent('ファイルのダウンロードが完了しました。');
					}
					// ユーザーがキャンセルした場合はメッセージを表示しない
				}
			} else {
				// File System Access API がサポートされていない場合は従来の方法
				fallbackDownload(blob, fileName);
				
				// 成功メッセージを表示
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				setDialogOpen(true);
				setDialogContent('ファイルのダウンロードが完了しました。');
			}
			
		} catch (error) {
			console.error('CSV download error:', error);
			const detailErrorMessage = 'CSVダウンロード処理でエラーが発生しました。\n(An error occurred during the CSV download process.)';
			commonError(error, detailErrorMessage);
		}
	};

	/**
	 * フォールバック用のダウンロード処理
	 * @param {Blob} blob ダウンロードするBlob
	 * @param {string} fileName ファイル名
	 */
	const fallbackDownload = (blob, fileName) => {
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', fileName);
		document.body.appendChild(link);
		link.click();
		
		// クリーンアップ
		document.body.removeChild(link);
		window.URL.revokeObjectURL(url);
	};

	/**
	 * CSVダウンロードボタンの活性制御
	 */
	const isDownloadButtonEnabled = () => {
		// スケジュールが1件以上存在する場合に活性
		return scheduleList && scheduleList.length > 0;
	};

	// フォームの値が変更されたときにボタンの状態を更新
	useEffect(() => {
		// 公開日時とアップロード日時の比較チェック
		checkOpenDateBeforeUpload();
	}, [
		formValues.scheduleName,
		fileList,
		uploadDate,
		uploadTime,
		formValues.promptyFlg,
		openDate,
		openTime,
		uploadDateFormatErrFlg,
		uploadDatePastErrFlg,
		uploadTimeFormatErrFlg,
		openDateFormatErrFlg,
		openDatePastErrFlg,
		openTimeFormatErrFlg,
		showScheduleForm,
		isResultCheckMode
	]);

	if (isLoading) {
		// ロード中の場合はローディング画面											
		return (
			<Loading />
		);
	} else {
		return (
			<Container className="uploadSchedule" maxWidth="lg">

				<Card className="card">
					<CardHeader
						title={t('uploadSchedule')}
						className="custom-card-header"
					/>
					<Typography className="description">
						{t('uploadScheduleDescription')}
					</Typography>
					<CardContent>
						<Grid container>
							{/* フォーム要素を横一列に配置 */}
							<Box display="flex" flexDirection="column" width="100%" gap={2}>
								{/* 1.対象フォルダ：サービス、企業、フォルダを横並び */}
								<Box display="flex" flexDirection="row" alignItems="flex-start" width="100%" gap={2}>
									{/* 1.対象フォルダ */}
									<Box display="flex" flexDirection="column">
										<Typography className="headerLabel" sx={{ mb: 1 }}>
											1.対象フォルダ
										</Typography>
										{/* 空のTextFieldまたはスペーサー */}
										<Box sx={{ height: '40px' }} /> {/* TextFieldと同じ高さのスペーサー */}
									</Box>

									{/* 右寄せのためのスペーサー */}
									<Box sx={{ width: '50px' }} />

									{/* サービス */}
									<Box display="flex" flexDirection="column">
										<Typography className="headerLabel" sx={{ mb: 0.5 }}>
											サービス名
										</Typography>
										<TextField
											value={formValues.auditName}
											className="textField-target"
											disabled
											size="small"
											sx={{ 
												width: '200px',
												'& .MuiInputBase-input.Mui-disabled': {
													color: '#333333', // 濃い黒色に変更
													WebkitTextFillColor: '#333333' // Safari対応
												}
											}}
										/>
									</Box>

									{/* 企業 */}
									<Box display="flex" flexDirection="column">
										<Typography className="headerLabel" sx={{ mb: 0.5 }}>
											企業名
										</Typography>
										<TextField
											value={formValues.orgName}
											className="textField-target"
											disabled
											size="small"
											sx={{ 
												width: '200px',
												'& .MuiInputBase-input.Mui-disabled': {
													color: '#333333', // 濃い黒色に変更
													WebkitTextFillColor: '#333333' // Safari対応
												}
											}}
										/>
									</Box>

									{/* フォルダ */}
									<Box display="flex" flexDirection="column">
										<Typography className="headerLabel" sx={{ mb: 0.5 }}>
											フォルダ名
										</Typography>
										<TextField
											value={formValues.projName}
											className="textField-target"
											disabled
											size="small"
											sx={{ 
												width: '200px',
												'& .MuiInputBase-input.Mui-disabled': {
													color: '#333333', // 濃い黒色に変更
													WebkitTextFillColor: '#333333' // Safari対応
												}
											}}
										/>
									</Box>
								</Box>

								{/* 2.連携共有フォルダ */}
								<Box display="flex" flexDirection="row" alignItems="center" width="100%" gap={2}>
									{/* 2.連携共有フォルダラベル */}
									<Typography className="headerLabel" sx={{ minWidth: '170px', width: '170px' }}>
										2.連携共有フォルダ
									</Typography>

									{/* 連携共有フォルダの値表示 */}
									<TextField
										className="textField-sharedfoldername"
										value={"\\\\" + shareFolderSeverName + "\\" + formValues.auditName + "\\" + formValues.orgName + "\\" + formValues.projName || ''}
										disabled={true}
										size="small"
										sx={{ 
											width: '600px',
											maxWidth: '600px',
											'& .MuiInputBase-input.Mui-disabled': {
												color: '#333333', // 濃い黒色に変更
												WebkitTextFillColor: '#333333' // Safari対応
											}
										}}
									/>

									{/* コピーアイコン（テキストボックスの右） */}
									<Tooltip 
										title="Copy To ClipBoard" 
										placement="top"
										arrow
									>
										<IconButton 
											size="large"
											onClick={() => {
												const textToCopy = "\\\\" + shareFolderSeverName + "\\" + formValues.auditName + "\\" + formValues.orgName + "\\" + formValues.projName;
												navigator.clipboard.writeText(textToCopy).then(() => {
													console.log('Copied to clipboard:', textToCopy);
												}).catch(err => {
													console.error('Failed to copy:', err);
												});
											}}
											sx={{ ml: 1 }}
										>
											<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
												<path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
											</svg>
										</IconButton>
									</Tooltip>
								</Box>
							</Box>

							{/* 共有フォルダユーザ設定の行 */}
							<Box display="flex" flexDirection="row" alignItems="center" width="100%" mt={2}>
								<Typography className="headerLabel" sx={{ mr: 2 }}>
									3.{t('settingSharedFolder')}
								</Typography>
								<TextField
									value={isSharedUserConfigured ? "設定済" : "未設定"}
									className="textField-status"
									InputProps={{
										readOnly: true,
										sx: {
											color: 'text.primary', // 通常のテキスト色を使用
											'& .MuiInputBase-input.Mui-disabled': {
												color: 'text.primary', // 無効化されても通常のテキスト色を維持
												WebkitTextFillColor: 'inherit' // Safari対応
											}
										}
									}}
									size="small"
									sx={{ mr: 2, width: '150px' }}
								/>
								<Button
									variant="primary"
									size="small"
									onClick={() => {
										// 必要なパラメータをオブジェクトにまとめる
										const param = {
											// org 関連
											orgLevel0Code: formValues.orgLevel0Code,
											orgName: formValues.orgName,

											// audit 関連
											auditCode: formValues.auditCode,
											auditName: formValues.auditName,

											// folderName
											projName: formValues.projName,
											projectCode: formValues.projectCode
										};

										// state オブジェクトを使用して画面遷移
										navigate('/settingSharedFolder', { state: param });
									}}
								>
									{t('setting')}
								</Button>
							</Box>

							{/* スケジュール設定 */}
							<Box mt={3}>
								<Box sx={{ 
									display: 'flex', 
									alignItems: 'center', 
									width: '100%', 
									mb: 1,
									minHeight: '32px' // 最小高さを指定
								}}>
									<Typography className="headerLabel" sx={{ flexShrink: 0, minWidth: '200px' }}>
										4.{t('scheduleSettings')}
									</Typography>
									<Box sx={{ flexGrow: 1, minWidth: '100px' }} /> {/* 最小幅を指定 */}
									<Typography 
										variant="body2" 
										color="textSecondary"
										sx={{ 
											flexShrink: 0, 
											textAlign: 'right',
											minWidth: '150px', // 最小幅を指定
											whiteSpace: 'nowrap' // 改行を防ぐ
										}}
									>
										登録件数：{scheduleList ? scheduleList.length : 0}/100件
									</Typography>
								</Box>
								{/* スケジュールが存在する場合のみリストとヘッダーを表示 */}
								{scheduleList && scheduleList.length > 0 && (
									<>
										{/* ヘッダー行 */}
										<Box display="flex" flexDirection="row" alignItems="center" width="100%" mb={1}>
											<Box width="80px" textAlign="center">
												<Typography variant="body2">{t('select')}</Typography>
											</Box>
											<Box width="150px" ml={1}>
												<Typography variant="body2">{t('scheduleName')}</Typography>
											</Box>
											<Box width="200px" ml={1}>
												<Typography variant="body2">ファイル名</Typography>
											</Box>
											<Box width="150px" ml={1}>
												<Typography variant="body2">{t('uploadDateTime')}</Typography>
											</Box>
											<Box width="150px" ml={1}>
												<Typography variant="body2">{t('status')}</Typography>
											</Box>
										</Box>

										{/* スケジュールリスト */}
										<Box sx={{ maxHeight: '310px', overflow: 'auto' }}>
											{scheduleList.slice(0, 100).map((schedule, index) => (
												<Box key={index} display="flex" flexDirection="row" alignItems="center" width="100%" mb={1}>
													<Box width="80px" textAlign="center">
													<Checkbox
														checked={schedule.selected || false}
														onChange={(e) => {
															const newScheduleList = [...scheduleList];
															newScheduleList.forEach((item, idx) => {
																item.selected = idx === index ? e.target.checked : false;
															});
															setScheduleList(newScheduleList);
														}}
													/>
													</Box>
													<Box width="150px" ml={1}>
														<Typography 
															variant="body2" 
															sx={{ 
																whiteSpace: 'nowrap', 
																overflow: 'hidden', 
																textOverflow: 'ellipsis' 
															}}
														>
															{schedule.scheduleName || ''}
														</Typography>
													</Box>
													<Box width="200px" ml={1}>
														<Typography 
															variant="body2"
															sx={{ 
																whiteSpace: 'nowrap', 
																overflow: 'hidden', 
																textOverflow: 'ellipsis' 
															}}
														>
															{schedule.fileNames || ''}
														</Typography>
													</Box>
													<Box width="150px" ml={1}>
														<Typography 
															variant="body2"
															sx={{ 
																whiteSpace: 'nowrap', 
																overflow: 'hidden', 
																textOverflow: 'ellipsis' 
															}}
														>
															{formatDateTime(schedule.uploadDateTime)}
														</Typography>
													</Box>
													<Box width="150px" ml={1}>
														<Typography 
															variant="body2"
															sx={{ 
																whiteSpace: 'nowrap', 
																overflow: 'hidden', 
																textOverflow: 'ellipsis' 
															}}
														>
															{schedule.status}
														</Typography>
													</Box>
												</Box>
											))}
										</Box>
									</>
								)}

								{/* ボタン行 - 常に表示 */}
								<Box display="flex" flexDirection="row" alignItems="center" mt={2} gap={2}>
									<Button
										variant="primary"
										size="small"
										onClick={() => {
											handleAddClick();
										}}
										disabled={!isSharedUserConfigured} // isSharedUserConfiguredがfalseの場合は非活性
									>
										{t('createNew')}
									</Button>

									{/* 他のボタンはスケジュールが存在する場合のみ表示 */}
									{scheduleList && scheduleList.length > 0 && (
										<>
											<Button
												variant="primary"
												size="small"
												onClick={handleCopyAddClick}
												disabled={!scheduleList.some(item => item.selected)}
											>
												{t('copyAndAdd')}
											</Button>

											<Button
												variant="primary"
												size="small"
												disabled={!scheduleList.some(item => item.selected)}
												onClick={handleEditClick}
											>
												{t('update')}
											</Button>

											<Button
												variant="primary"
												size="small"
												onClick={handleDeleteClick}
												disabled={!scheduleList.some(item => item.selected)}
											>
												{t('delete')}
											</Button>

											<Button
												variant="primary"
												size="small"
												disabled={!scheduleList.some(item => item.selected) || !isResultCheckButtonEnabled()}
												onClick={handleResultCheckClick}
											>
												{t('checkResults')}
											</Button>
											{/* CSVダウンロードボタンを追加 - 「結果確認」ボタンの横に配置 */}
											<Tooltip 
												title="サービス全てのスケジュール一覧をCSVファイルでダウンロードします" 
												placement="top"
												arrow
											>
												<span>
													<Button
														variant="primary"
														size="small"
														disabled={!isDownloadButtonEnabled()}
														onClick={handleDownloadCSV}
													>
														<Download />
														{t('csvDownload')}
													</Button>
												</span>
											</Tooltip>

										</>
									)}
								</Box>
							</Box>

						</Grid>

						{/* 区切り線 */}
						<Box mt={3} mb={3}>
							<Divider />
						</Box>

						{showScheduleForm && (
							<>
								{/* 1.スケジュール名 */}
								<Box display="flex" flexDirection="column" width="100%" mb={2}>
									<Typography className="headerLabel" sx={{ mb: 1 }}>
										1.{t('scheduleName')}
										<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
									</Typography>
									<Box sx={{ ml: 2 }}>
										<TextField
											className="textField-schedule"
											size="small"
											fullWidth
											value={formValues.scheduleName || ''}
											onChange={(e) => setFormValues({
												...formValues,
												scheduleName: e.target.value
											})}
											disabled={isResultCheckMode} // 結果確認モードでは非活性
											error={isDuplicateScheduleName(formValues.scheduleName)} // エラー状態を追加
										/>
										{/* エラーメッセージを追加 */}
										{isDuplicateScheduleName(formValues.scheduleName) && !isResultCheckMode && (
											<Typography 
												variant="caption" 
												sx={{ 
													color: 'red', 
													mt: 0.5,
													display: 'block'
												}}
											>
												{setMessage(t('message.1007032'), [])}
											</Typography>
										)}
									</Box>
								</Box>

								{/* 2.共有フォルダ名 */}
								<Grid item md={12} className="griditem">
									<Box display="flex" alignItems="center" gap={0}>
										<Typography className="headerLabel" sx={{  minWidth: '170px', width: '170px', mb: 0 }}>
											2.{t('sharedFolderName')}
										</Typography>
										{/* 共有フォルダ名部分の幅を広げる */}
										<Box sx={{ width: '650px', mr: 0 }}>
											<TextField
												className="textField-sharedfoldername"
												value={"\\\\" + shareFolderSeverName + "\\" + formValues.auditName + "\\" + formValues.orgName + "\\" + formValues.projName || ''}
												fullwidth
												disabled={true}
												fullWidth
												size="small"
												sx={{
													width: '100%',
													'& .MuiInputBase-input.Mui-disabled': {
														color: '#333333', // 濃い黒色に変更
														WebkitTextFillColor: '#333333' // Safari対応
													}
												}}
											/>
										</Box>
										{/* ★★★ 追加：コピーアイコン ★★★ */}
										<Tooltip 
											title="Copy To ClipBoard" 
											placement="top"
											arrow
										>
											<IconButton 
												size="large"
												onClick={() => {
													const textToCopy = "\\\\" + shareFolderSeverName + "\\" + formValues.auditName + "\\" + formValues.orgName + "\\" + formValues.projName;
													navigator.clipboard.writeText(textToCopy).then(() => {
														console.log('Copied to clipboard:', textToCopy);
													}).catch(err => {
														console.error('Failed to copy:', err);
													});
												}}
												sx={{ ml: -1 }}
											>
												<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
													<path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
												</svg>
											</IconButton>
										</Tooltip>
									</Box>
								</Grid>

								{/* 3. ファイル名 */}
								<br />
								<Grid item md={12} className="griditem">
									{/* ファイル名ラベル */}
									<Typography className="headerLabel" sx={{ mb: 1 }}>
										3.{t('fileName')}
										<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
									</Typography>
									
								{/* ファイル選択ドロップダウンをラベルの下に移動 */}
								<Box sx={{ ml: 0, mb: 2, display: 'flex', alignItems: 'flex-start', gap: 1 }}>
								<Box sx={{ width: '250px' }}> {/* flexGrow: 1 を固定幅に変更 */}
										<FileSelectBox
											className="fileSelectBox"
											selectedFileNames={selectedFileNamesFromFolder}
											shareFileList={shareFileList}
											disabled={isResultCheckMode}
											onFileSelect={isResultCheckMode ? () => {} : handleFileSelectFromFolder}
										/>
									</Box>
									
									{/* リフレッシュボタンを横に配置 */}
									<Tooltip 
										title="ファイル一覧を更新" 
										placement="top"
										arrow
									>
										<IconButton 
											onClick={handleRefreshFileList}
											disabled={isResultCheckMode}
											size="small"
											sx={{
												mt: 5.5, // 上からのマージンを追加して下に移動 
												color: 'primary.main',
												'&:hover': {
													backgroundColor: 'primary.light',
													color: 'primary.dark'
												}
											}}
										>
											<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
												<path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>
											</svg>
										</IconButton>
									</Tooltip>
								</Box>

								{/* ファイル追加ボタン */}
								<Box sx={{ ml: 2, mb: 2 }}>
									{/* ファイル追加ラベルを追加 */}
									<Typography variant="body2" sx={{ mb: 1, fontWeight: 'medium' }}>
										ファイルを追加
									</Typography>
									<Button
										variant="primary"
										size="small"
										sx={{ width: 'fit-content' }}
										onClick={() => setFileList([...fileList, { name: '' }])}
										disabled={isResultCheckMode} // 結果確認モードでは非活性
									>
										{t('addFile')}
									</Button>
								</Box>									
									{/* ファイルリスト表示部分 */}
									{fileList.map((file, index) => (
										<Box key={index} display="flex" flexDirection="column" sx={{ ml: 2, mb: 2 }}>
											<Box display="flex" alignItems="center">
												<TextField
													className="textField-fileName"
													size="small"
													value={file.name || ''}
													onChange={(e) => {
														const newFileName = e.target.value;
														const oldFileName = file.name;
														
														// ファイルリストを更新
														const newFileList = [...fileList];
														newFileList[index].name = newFileName;
														setFileList(newFileList);
														
														// 元のファイル名がフォルダから選択されたファイルの場合、チェックボックスを外す
														if (oldFileName && selectedFileNamesFromFolder.includes(oldFileName)) {
															setSelectedFileNamesFromFolder(prevSelected => 
																prevSelected.filter(fileName => fileName !== oldFileName)
															);
															console.log(`Removed ${oldFileName} from folder selection due to name change`);
														}
													}}
													placeholder="ファイル名を入力"
													fullWidth
													disabled={isResultCheckMode} // 結果確認モードでは非活性
													error={!file.name || file.name.trim() === ''} // エラー状態を追加
												/>

												{/* 結果確認モードの場合はステータス列を表示 */}
												{isResultCheckMode && (
													<Box sx={{ width: '400px', ml: 2 }}>
														<TextField
															size="small"
															value={file.status || '正常'}
															disabled={true}
															fullWidth
															InputProps={{
																sx: {
																	color: file.status === 'エラー' ? 'error.main' : 'text.primary',
																	'& .MuiInputBase-input.Mui-disabled': {
																		color: file.status === 'エラー' ? 'error.main' : 'text.primary',
																		WebkitTextFillColor: 'inherit'
																	}
																}
															}}
														/>
													</Box>
												)}
												{/* 結果確認モードでない場合のみゴミ箱アイコンを表示 */}
												{!isResultCheckMode && (
													<IconButton 
														onClick={() => handleDeleteFile(index)}
														size="small"
														color="error"
														sx={{ ml: 1 }}
													>
														<Trash />
													</IconButton>
												)}
											</Box>
											{/* エラーメッセージを追加 */}
											{(!file.name || file.name.trim() === '') && (
												<Typography 
													variant="caption" 
													sx={{ 
														color: 'red', 
														mt: 0.5,
														ml: 0
													}}
												>
													{setMessage(t('message.1007041'), [])}
												</Typography>
											)}
										</Box>
									))}
								</Grid>
								{/* 空の行 */}
								<br /><br />
								{/* 4.アップロード日時 */}
								<Box display="flex" flexDirection="column" width="100%" mb={2}>
									<Typography className="headerLabel" sx={{ mb: 1 }}>
										4.{t('uploadDateTime')}
										<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
									</Typography>
									<Box sx={{ ml: 2 }}>
										<Box display="flex" flexDirection="row" alignItems="center" gap={2}>
											<DatePicker
												className='uploadDate'
												value={uploadDate}
												helperText={
													uploadDateFormatErrFlg 
														? t('message.1000400') 
														: uploadDatePastErrFlg 
															? t('message.1001300') 
															: ''
												}
												onInputChange={inputUploadDate}
												minDate={new Date()}
												error={uploadDateFormatErrFlg || uploadDatePastErrFlg}
												placeholder="yyyy/mm/dd"
												dateFormat='yyyy/MM/DD'
												disabled={isResultCheckMode} // 結果確認モードでは非活性
											/>
											<TimePicker
												value={uploadTime}
												helperText={uploadTimeFormatErrFlg ? t('message.1001600') : ''}
												onChange={inputUploadTime}
												error={uploadTimeFormatErrFlg}
												disabled={isResultCheckMode} // 結果確認モードでは非活性

											/>
										</Box>
										{/* 条件付きで注意書きを表示 */}
										{(() => {
											// 結果確認モードの場合は何も表示しない
											if (isResultCheckMode) {
												return null;
											}
											return null;
										})()}
									</Box>
								</Box>
								{/* 5. 特記事項(optional) */}
								<Grid item md={12} className="griditem notices">
									<Typography className="headerLabel" sx={{ mb: 1 }}>
										5.{t('notice')}(optional)
									</Typography>
									<Box sx={{ ml: 2 }}>
										<TextField
											// label={'5. ' + t('notice')}
											helperText={formValues.notices.length > 300 ? setMessage(t('message.1000300'), [t('notice').toLowerCase(), 300]) : t('helperTextNotice')}
											value={formValues.notices}
											onChange={(e) => setFormValues({ ...formValues, notices: e.target.value })}
											error={formValues.notices.length > 300}
											multiline
											minRows="2"
											// optional
											fullWidth
											disabled={isResultCheckMode} // 結果確認モードでは非活性
										/>
									</Box>
								</Grid>
								{/* 空の行 */}
								<br /><br />
								{/* 6. お知らせ(optional) */}
								<Grid item md={12} className="griditem information">
									<Typography className="headerLabel" sx={{ mb: 1 }}>
										6.{t('information')}(optional)
									</Typography>
									<Box sx={{ ml: 2 }}>
										<TextField
											// label={'6. ' + t('information')}
											helperText={formValues.information.length > 300 ? setMessage(t('message.1000300'), [t('information').toLowerCase(), 300]) : t('helperTextInformation')}
											value={formValues.information}
											onChange={(e) => setFormValues({ ...formValues, information: e.target.value })}
											error={formValues.information.length > 300}
											multiline
											minRows="2"
											// optional
											fullWidth
											disabled={isResultCheckMode} // 結果確認モードでは非活性
										/>
									</Box>
								</Grid>
								{/* 7. 公開日時 */}
								<Grid item md={12} className="griditem openDateChk">
									<Typography className="headerLabel" sx={{ mb: 1 }}>
										7.{t('publishedDate')}
										<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
									</Typography>
									<Box sx={{ ml: 2 }}>
										<FormControl component="fieldset">
											<RadioGroup
												value={formValues.promptyFlg}
												onChange={(e) => {
													if (e.target.value === PROMPTLY_FLG.PUBLISH_IMMEDIATELY) {
														selectPublishImmediately();
													} else {
														setFormValues({ ...formValues, promptyFlg: PROMPTLY_FLG.PUBLISH_SELECT_DATE });
													}
												}}
											>
												<FormControlLabel
													value={PROMPTLY_FLG.PUBLISH_IMMEDIATELY}
													control={<Radio disabled={isResultCheckMode} />} // 結果確認モードでは非活性
													label={t('publishImmediately')}
													sx={{ 
														gap: '-10px',  // 負の値でより密着させる
														'& .MuiFormControlLabel-label': {
															marginLeft: '-40px'
														}
													}}
												/>
												<FormControlLabel
													value={PROMPTLY_FLG.PUBLISH_SELECT_DATE}
													control={<Radio disabled={isResultCheckMode} />} // 結果確認モードでは非活性
													label={t('publishSelectedDatetime')}
													sx={{ 
														gap: '-10px',  // 負の値でより密着させる
														'& .MuiFormControlLabel-label': {
															marginLeft: '-40px'
														}
													}}
												/>
											</RadioGroup>
										</FormControl>
									</Box>
									<div>
										<Box sx={{ ml: 2 }}>
											<DatePicker
												className='openDate'
												value={formValues.openDisplayDate}
												helperText={openDateFormatErrFlg ? t('message.1000400') : openDatePastErrFlg ? t('message.1001300') : ''}
												onChange={(newValue) => {
													setOpenDate(newValue);
													setFormValues(prev => ({
														...prev,
														openDate: newValue,
														openDisplayDate: newValue // 両方を同期
													}));
												}}
												minDate={new Date()}
												error={openDateFormatErrFlg || openDatePastErrFlg}
												placeholder="yyyy/mm/dd"
												dateFormat='yyyy/MM/DD'
												disabled={isResultCheckMode || formValues.promptyFlg === PROMPTLY_FLG.PUBLISH_IMMEDIATELY} // 結果確認モードでは非活性
											/>
											<TimePicker
												className='openTime'
												value={openTime}
												helperText={openTimeFormatErrFlg ? t('message.1001600') : ''}
												onChange={inputTime}
												error={openTimeFormatErrFlg}
												disabled={isResultCheckMode || formValues.promptyFlg === PROMPTLY_FLG.PUBLISH_IMMEDIATELY} // 結果確認モードでは非活性
											/>
										</Box>
										{/* アップロード日時より前のエラーメッセージを表示 */}
										{openDateBeforeUploadErrFlg && !isResultCheckMode && (
											<Typography 
												variant="caption" 
												sx={{ 
													color: 'red', 
													mt: 1,
													display: 'block',
													ml: 2
												}}
											>
												{t('message.1007022')}
											</Typography>
										)}
									</div>
									{formValues.promptyFlg === PROMPTLY_FLG.PUBLISH_SELECT_DATE && (!openDate || openTime === '') && (
										<Typography className='errorMessage' variant='caption'>
											{t('message.1001400')}
										</Typography>
									)}
								</Grid>
								{/* 8. 通知メールの送信 */}
								<Grid item md={12} className="griditem mailSendChk">
									<Typography className="headerLabel" sx={{ mb: 1 }}>
										8.{t('sendMail')}
										<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
									</Typography>
									<div />
									<Box sx={{ ml: 2 }}>
										<FormControl component="fieldset">
											<RadioGroup
												value={formValues.noSendFlg}
												onChange={(e) => setFormValues({ ...formValues, noSendFlg: e.target.value })}
											>
												<FormControlLabel
													value={NO_SEND_FLG.SEND}
													control={<Radio disabled={isResultCheckMode} />} 
													label={t('sendPublishDate')}
													sx={{ 
														gap: '-10px',  // 負の値でより密着させる
														'& .MuiFormControlLabel-label': {
															marginLeft: '-40px'
														}
													}}
												/>
												<FormControlLabel
													value={NO_SEND_FLG.NO_SEND}
													control={<Radio disabled={isResultCheckMode} />}
													label={t('noSend')}
													sx={{ 
														gap: '-10px',  // 負の値でより密着させる
														'& .MuiFormControlLabel-label': {
															marginLeft: '-40px'
														}
													}}
												/>
											</RadioGroup>
										</FormControl>
									</Box>
								</Grid>
								{/* ★★★ 追加：9. ファイル保管期間 ★★★ */}
								<Grid item md={12} className="griditem filePeriod">
									<Typography className="headerLabel" sx={{ mb: 1, mt: 2 }}>
										9.{t('filePeriod')}
										<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
									</Typography>
									<Box sx={{ ml: 2 }}>
										<div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '8px' }}>
											<Radio
												label="15日間"
												style={{ marginLeft: '-4px', margin: 0, padding: 0 }}
												checked={formValues.filePeriod === FILE_PERIOD.DAYS_15}
												onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_15 })}
												disabled={isResultCheckMode}
											/>
											<Radio
												label="30日間"
												style={{ marginLeft: '10px', margin: 0, padding: 0 }}
												checked={formValues.filePeriod === FILE_PERIOD.DAYS_30}
												onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_30 })}
												disabled={isResultCheckMode}
											/>
											<Radio
												label="45日間"
												style={{ marginLeft: '10px', margin: 0, padding: 0 }}
												checked={formValues.filePeriod === FILE_PERIOD.DAYS_45}
												onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_45 })}
												disabled={isResultCheckMode}
											/>
											<Radio
												label="60日間"
												style={{ marginLeft: '10px', margin: 0, padding: 0 }}
												checked={formValues.filePeriod === FILE_PERIOD.DAYS_60}
												onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_60 })}
												disabled={isResultCheckMode}
											/>
											<Radio
												label="75日間"
												style={{ marginLeft: '10px', margin: 0, padding: 0 }}
												checked={formValues.filePeriod === FILE_PERIOD.DAYS_75}
												onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_75 })}
												disabled={isResultCheckMode}
											/>
											<Radio
												label="90日間"
												style={{ marginLeft: '10px', margin: 0, padding: 0 }}
												checked={formValues.filePeriod === FILE_PERIOD.DAYS_90}
												onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_90 })}
												disabled={isResultCheckMode}
											/>
										</div>
									</Box>
								</Grid>
								{/* 区切り線 */}
								<Box mt={3} mb={3}>
									<Divider />
								</Box>
							</>
						)}

						<Grid container justifyContent="center" className='button'>
							<Button
								className="submitBtn"
								variant="primary"
								onClick={handleSubmitClick}
								disabled={!isFormValid()}
							>
								{t('submit')}
							</Button>
							<Button
								className="cancelBtn"
								variant="secondary"
								onClick={handleCancelClick}
							>
								{t('cancel')}
							</Button>
						</Grid>
					</CardContent>
				</Card>

				{(dialogStatus === DIALOG_STATUS.OK_DIALOG || dialogStatus === DIALOG_STATUS.OK_DIALOG_BACK) && (
					<Dialog
						isOpen={dialogOpen}
						content={dialogContent}
						onOk={onOk}
					/>
				)}
				{(dialogStatus === DIALOG_STATUS.DETAIL_DIALOG || dialogStatus === DIALOG_STATUS.DETAIL_DIALOG_BACK) && (
					<DetailDialog
						isOpen={dialogOpen}
						content={dialogContent}
						detailContent={detailContent}
						onOk={onOk}
					/>
				)}
				{(dialogStatus === DIALOG_STATUS.SAVE_CONFIRM_DIALOG) && (
					<ConfirmDialog
						isOpen={confirmDialogOpen}
						content={confirmDialogContent}
						onOk={submitProcess}
						onCancel={onCancel}
					/>
				)}
				{(dialogStatus === DIALOG_STATUS.CANCEL_CONFIRM_DIALOG) && (
					<ConfirmDialog
						isOpen={confirmDialogOpen}
						content={confirmDialogContent}
						onOk={cancelEdit}
						onCancel={onCancel}
					/>
				)}
				{(dialogStatus === DIALOG_STATUS.SWITCH_CONFIRM_DIALOG) && (
					<ConfirmDialog
						isOpen={confirmDialogOpen}
						content={confirmDialogContent}
						onOk={handleConfirmDialog}
						onCancel={onCancel}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.DELETE_CONFIRM_DIALOG && (
					<ConfirmDialog
						isOpen={confirmDialogOpen}
						content={confirmDialogContent}
						onOk={() => {
							const selectedSchedule = scheduleList.find(item => item.selected);
							if (selectedSchedule) {
								deleteScheduleProcess(selectedSchedule.scheduleNo);
							}
						}}
						onCancel={onCancel}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.COMPLETE_DIALOG && (
					<Dialog
						isOpen={dialogOpen}
						content={dialogContent}
						onOk={onOk}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.SAVE_SUCCESS_DIALOG && (
					<Dialog
						isOpen={dialogOpen}
						content={dialogContent}
						onOk={onFinished}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.COPY_SWITCH_CONFIRM_DIALOG && (
					<ConfirmDialog
						isOpen={confirmDialogOpen}
						content={confirmDialogContent}
						onOk={handleConfirmDialog}
						onCancel={onCancel}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.FORM_SWITCH_CONFIRM_DIALOG && (
					<ConfirmDialog
						isOpen={confirmDialogOpen}
						content={confirmDialogContent}
						onOk={handleConfirmDialog}
						onCancel={onCancel}
					/>
				)}
			</Container>
		);
	}
}
export default UploadSchedule;